<template>
  <el-row
    class="pageSize"
    style="margin: 0 auto; padding-top: 15px"
    v-loading="loading"
  >
    <el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
          style="height: 30px"
        >
        </el-col>
        <el-col
          :span="14"
          class="suitability_home left_text_align"
          @click.native="backHome"
          style="cursor: pointer"
        ><i class="el-icon-s-home"></i>返回主页菜单<div class="imgs_logo" /></el-col>
        <el-col
          :span="9"
          @click.native="logoutAccount"
          class="suitability_home right_text_align"
          style="cursor: pointer"
        >
          <span class="font_title_email">{{ account }}</span><span>[退出]</span>
        </el-col>
      </el-row>
      <el-row class="padding_30px_bottom padding_10px_top">
        <el-col
          :span="1"
          class="el-tabs__item el-tabs__item"
        > </el-col>
        <el-col
          :span="5"
          class="suitability_home_title left_text_align"
        >基金排行榜</el-col>
        <el-col
          :span="5"
          class="suitability_home_title left_text_align"
          style="display: inline-block; margin-left: -30px"
        >
          <el-radio
            id="rdDailyRanking"
            v-model="rankingType"
            label="dailyRanking"
            :disabled="disableDailyRanking"
            style="margin-right: 5px !important"
          >每日排行榜 </el-radio>
          <el-radio
            id="rdMonthlyRanking"
            v-model="rankingType"
            label="monthlyRanking"
            :disabled="disableMonthlyRanking"
          >月度排行榜
          </el-radio>
        </el-col>
        <el-col
          :span="13"
          class="suitability_home_title right_text_align"
          style="
                        display: inline-block;
                        text-align: right;
                        margin-left: 30px;
                    "
        >
          <el-select
            v-model="searchTypeSel"
            @change="selectFundOrCompany"
            clearable
            id="elselectFundOrCompany"
          >
            <el-option
              selected="selected"
              label="基金"
              value="selectFund"
            ></el-option>
            <el-option
              label="基金公司"
              value="selectCompany"
            ></el-option>
          </el-select><el-select
            v-model="company"
            v-show="isShowCompanySelect"
            filterable
            placeholder="请选择或输入公司首拼、关键字"
            :filter-method="fiterCompany"
            clearable
            style="width: 230px !important"
            id="elselectCompany"
          >
            <el-option
              v-for="item in filteredCompanyList"
              :key="item.companyName"
              :label="item.companyName"
              :value="item.companyId"
            >
            </el-option>
          </el-select>
          <el-popover
            placement="bottom"
            style="width: 230px !important"
            v-show="!isShowCompanySelect"
            v-model="searchPopoverVisible"
          >
            <el-row
              style="width: 380px; height: 300px"
              v-loading="loading2"
            >
              <el-scrollbar
                ref="search_scrollbar"
                style="height: 100%"
              >
                <el-row
                  style="
                                        text-align: left;
                                        margin: 0;
                                        font-size: 12px;
                                        cursor: pointer;
                                    "
                  v-for="(node, index) in state"
                  class="fundInformation"
                  :key="index"
                >
                  <el-col
                    :span="24"
                    v-html="node"
                    @click.native="getFundInformation(node)"
                    :ref="'cssClass' + index"
                    @mouseenter.native="
                                            changeClass($event, index)
                                        "
                    :class="{ searchHover: 1 === index }"
                  ></el-col>
                </el-row>
              </el-scrollbar>
            </el-row>
            <el-input
              v-model="symbolInfo"
              slot="reference"
              placeholder="请输入基金代码或基金名称"
              type="text"
              suffix-icon="el-icon-search"
              @input="searchFundCache(symbolInfo)"
              @keyup.enter.native="submitSearch"
              style="width: 230px !important"
              id="elselectFund"
            ></el-input>
          </el-popover>

          <el-date-picker
            v-model="dateValue"
            align="right"
            type="date"
            clearable
            placeholder="查看历史数据"
            value-format="yyyy-MM-dd"
            style="width: 140px !important"
            :picker-options="pickerOptions"
            v-show="showDailylyRankingDate"
            @change="changeDailyDate"
          >
          </el-date-picker>

          <el-date-picker
            v-model="dateValueMonthly"
            align="right"
            type="month"
            :clearable="false"
            placeholder="查看历史数据"
            value-format="yyyy-MM"
            style="width: 140px !important"
            :picker-options="pickerOptionsMonthly"
            v-show="showMonthlyRankingDate"
            @change="changeMonthlyDate"
          >
          </el-date-picker>

          <!--el-button
            icon="icon_export"
            @click="downloadFile()"
            :disabled="disableExport"
            style="width:140px !important;"
          >导出EXCEL</el-button-->

            <el-popover            
            placement="bottom"
            width="100"
            trigger="click"
            v-model="exportVisible"
            popper-class="ranking-exportExcel"
          >
            <ul style="display: flex;flex-direction: column;">
              <el-button
                type="text"
                @click="onceSendDialogVisible=true"
              >立即导出</el-button>
              <el-button
                type="text"
                style="margin-left:0px;"
                @click="fillConfigData()"
                v-show="rankingType === 'dailyRanking'"
              >定期发送</el-button>
              <el-button
                type="text"
                style="margin-left:0px;"
                @click="fillConfigDataMonthly()"
                v-show="rankingType === 'monthlyRanking'"
              >定期发送</el-button>
            </ul>
            <el-button
              :disabled="disableExport"
              slot="reference"
              icon="icon_export"
            >导出EXCEL</el-button>
          </el-popover>

        </el-col>
      </el-row>
    </el-row>
    <el-row>
      <el-dialog
        width="250px"
        :visible.sync="onceSendDialogVisible"
        center
        :modal-append-to-body="false"
        :show-close="false"
        custom-class="customDialog"
      >
        <p style="text-align: center; font-weight: bold">
          导出EXCEL文件
        </p>
        <el-select
          v-model="exportOption"
          placeholder="请选择"
        >
          <el-option
            label="当前列表"
            value="currentList"
          >
          </el-option>
          <el-option
            label="所有基金列表"
            value="fullList"
          >
          </el-option>
        </el-select>
        <div style="text-align: center; margin-top: 15px">
          <el-button
            size="mini"
            round
            @click="onceSendDialogVisible=false"
          >取消</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="exportList()"
            round
          >导出</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="configSendDialogVisible"
        width="525px"
        center
        :modal-append-to-body="false"
        :show-close="false"
        custom-class="customDialog"
      >
        <el-row v-loading="dialogLoading">
          <el-col
            :span="1"
            class="height_1px"
          ></el-col>
          <el-col :span="23">
            <el-row>
              <el-col class="dialog_title">设置发送条件</el-col>
            </el-row>
            <br />
            <el-row>
              <el-col
                :span="8"
                class="dialog_font"
              >发送频率</el-col>
              <el-col :span="15">
                <el-select
                  v-if="showDailylyRankingDate"
                  v-model="selectFrequencyDaily"
                  class="frequency_input"
                >
                  <el-option
                    value="daily"
                    label="每日"
                  >
                  </el-option>
                  <el-option
                    value="weekly"
                    label="每周"
                  >
                  </el-option>
                  <el-option
                    value="monthly"
                    label="每月"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-if="showMonthlyRankingDate"
                  v-model="selectFrequencyMonthly"
                  class="frequency_input"
                >
                  <el-option
                    value="monthly"
                    label="每月"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <br />
            <el-row>
              <el-col
                :span="8"
                class="dialog_font"
                style="line-height: 244px;"
              >发送邮箱</el-col>
              <el-col
                :span="16"
                style="width: 253px;"
              >
                <el-col style="
                                            border-radius: 0px;
                                            width: 300px;
                                            border: 1px solid #c0c4cc;
                                            height: 244px;
                                        ">
                  <el-scrollbar
                    ref="scrollbar"
                    style="height: 100%;"
                  >
                    <el-col
                      v-for="item in emailsParagraph"
                      :key="item.index"
                      :span="24"
                      class="padding_4px"
                    >
                      <el-tag
                        type="info"
                        closable
                        @close="
                                                        handleRemoveEmail(item)
                                                    "
                      >{{ item }}</el-tag>
                    </el-col>
                  </el-scrollbar>
                </el-col>
              </el-col>
            </el-row>
            <br />
            <el-row>
              <el-col
                :span="8"
                class="dialog_font"
              >添加发送邮箱</el-col>
              <el-col :span="16">
                <el-input
                  placeholder="请输入内容"
                  v-model="emailInput"
                  class="input-with-select"
                  @keyup.enter.native="
                                            handleAddEmail(emailInput)
                                        "
                >
                  <el-button
                    slot="append"
                    @click="handleAddEmail(emailInput)"
                    :disabled="disableExport"
                  >添加</el-button>
                </el-input>
              </el-col>
            </el-row>
            <br />
            <el-row>
              <el-col :span="14">
                <el-button
                  size="small"
                  class="button_space"
                  round
                  @click="
                                            sendRankReport()
                                        "
                  :disabled="disableExport"
                >立即发送</el-button>
              </el-col>
              <el-col
                :span="4"
                class="right_text_align"
                style="padding-right: 85px;"
              >
                <el-button
                  size="small"
                  class="button_space"
                  round
                  @click="configSendDialogVisible = false"
                >取 消</el-button>
              </el-col>
              <el-col
                :span="4"
                class="right_text_align padding_20px_left"
              >
                <el-button
                  size="small"
                  class="button_space"
                  type="primary"
                  round
                  @click="savaSubscritionInfo"
                >保 存</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-dialog>

      <el-dialog
        :visible.sync="configSendDialogVisibleMonthly"
        width="525px"
        center
        :modal-append-to-body="false"
        :show-close="false"
        custom-class="customDialog"
      >
        <el-row v-loading="dialogLoading">
          <el-col
            :span="1"
            class="height_1px"
          ></el-col>
          <el-col :span="23">
            <el-row>
              <el-col class="dialog_title">设置发送条件</el-col>
            </el-row>
            <br />
            <el-row style="display: none;">
              <el-col
                :span="8"
                class="dialog_font"
              >添加基金公司</el-col>
              <el-col :span="16">
                <el-select                    
                    v-model="curCompanyNameMonthly"
                    filterable
                    clearable
                    placeholder="请选择或输入公司首拼、关键字"
                    :filter-method="fiterCompanyMonthly"
                    class="input-with-select"                  
                  >
                    <el-option
                      v-for="item in filteredCompanyListMonthly"
                      :key="item.companyName"
                      :label="item.companyName"
                      :value="item.companyName"
                    >
                    </el-option>
                  </el-select><el-button                      
                      @click="handleAddCompanyMonthly(curCompanyNameMonthly)"                                     
                    >添加</el-button>
              </el-col>
            </el-row>
            <br style="display: none;"/>
            <el-row style="display: none;">
                <el-col
                  :span="8"
                  class="dialog_font"
                  style="line-height: 244px;"
                >基金公司列表</el-col>
                <el-col
                  :span="15"
                  style="width: 253px;"                  
                >
                  <el-col style="
                                            border-radius: 0px;
                                            width: 300px;
                                            border: 1px solid #c0c4cc;
                                            height: 244px;
                                        ">
                    <el-scrollbar
                      ref="scrollbarMyListMonthly"
                      style="height: 100%;"                      
                    >
                      <el-col
                        v-for="item in myListCompanyMonthly"
                        :key="item.index"
                        :span="24"
                        class="padding_4px"                        
                      >
                        <el-tag
                          type="info"         
                          closable
                          @close="handleRemoveCompanyMonthly(item)"                          
                        >{{ item }}</el-tag>
                      </el-col>
                    </el-scrollbar>
                  </el-col>
                </el-col>
              </el-row>
            <br/>
            <el-row>
              <el-col
                :span="8"
                class="dialog_font"
                style="line-height: 244px;"
              >发送邮箱</el-col>
              <el-col
                :span="16"
                style="width: 253px;"
              >
                <el-col style="
                                            border-radius: 0px;
                                            width: 300px;
                                            border: 1px solid #c0c4cc;
                                            height: 244px;
                                        ">
                  <el-scrollbar
                    ref="scrollbarMonthly"
                    style="height: 100%;"
                  >
                    <el-col
                      v-for="item in emailsParagraphMonthly"
                      :key="item.index"
                      :span="24"
                      class="padding_4px"
                    >
                      <el-tag
                        type="info"
                        closable
                        @close="
                                                        handleRemoveEmailMonthly(item)
                                                    "
                      >{{ item }}</el-tag>
                    </el-col>
                  </el-scrollbar>
                </el-col>
              </el-col>
            </el-row>
            <br />
            <el-row>
              <el-col
                :span="8"
                class="dialog_font"
              >添加发送邮箱</el-col>
              <el-col :span="16">
                <el-input
                  placeholder="请输入内容"
                  v-model="emailInputMonthly"
                  class="input-with-select"
                  @keyup.enter.native="
                                            handleAddEmailMonthly(emailInputMonthly)
                                        "
                >
                  <el-button
                    slot="append"
                    @click="handleAddEmailMonthly(emailInputMonthly)"
                    
                  >添加</el-button>
                </el-input>
              </el-col>
            </el-row>
            <br />
            <el-row>
              <el-col :span="14">
                <el-button
                  size="small"
                  class="button_space"
                  round
                  @click="
                                            sendRankReportMonthly()
                                        "
                  :disabled="disableExport"
                >立即发送</el-button>
              </el-col>
              <el-col
                :span="4"
                class="right_text_align"
                style="padding-right: 85px;"
              >
                <el-button
                  size="small"
                  class="button_space"
                  round
                  @click="configSendDialogVisibleMonthly = false"
                >取 消</el-button>
              </el-col>
              <el-col
                :span="4"
                class="right_text_align padding_20px_left"
              >
                <el-button
                  size="small"
                  class="button_space"
                  type="primary"
                  round
                  @click="savaSubscritionInfoMonthly"
                >保 存</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-dialog> 

    </el-row>
    <el-row
      v-show="!monthlyRankSignOff()"
      style="
                margin-bottom: 10px;
                font-size: 14px;
                color: #676767;
                font-weight: bold;
            "
    >
      <el-col
        :span="14"
        style="color: #ef7621"
      >提醒：部分特殊类型基金业绩更新延迟，最终排名或有微调，如需即时引用请注明引用时间。
      </el-col>
      <el-col
        :span="10"
        class="right_text_align"
      >更新时间：<span v-html="monthlyLastUpdate"></span></el-col>
    </el-row>
    <el-row v-show="isShowRankingTab">
      <el-row v-show="showDailylyRankingDate">
        <el-col
          v-show="searchTypeSel === '' && company === ''"
          :span="24"
          class="right_text_align ranking-search-return padding-right-20-important"
          style="position: absolute; z-index: 999"
        ><span v-html="rankingRatio"></span>
          <el-tooltip
            class="item"
            effect="light"
            content="部分特殊类型基金（例如FOF、QDII、新成立产品及其它情形）净值更新有所延迟"
            placement="bottom-end"
          >
            <i class="el-icon-info-ms"></i> </el-tooltip>
        </el-col>
      </el-row>

      <el-row v-show="showMonthlyRankingDate">
        <el-col
          v-show="searchTypeSel === '' && company === ''"
          :span="24"
          class="right_text_align ranking-search-return padding-right-20-important"
          style="position: absolute; z-index: 999"
        ><span>月榜数据截止日为最后一个自然日</span>
          <el-tooltip
            class="item"
            effect="light"
            content="月榜数据截止日为当月度最后一个自然日，如该月末日未公布净值，则向前取最新一个交易日净值；各回报期间的起始日仍然为月末日对应的起始日期，同样地，如对应起始日期无净值，则向前取最新一个交易日净值。"
            placement="bottom-end"
          >
            <i class="el-icon-info-ms"></i> </el-tooltip>
        </el-col>
      </el-row>

      <el-col
        :span="1"
        class="line_border_bottom el-tabs__item"
      >
      </el-col>
      <el-col :span="23">
        <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="latestReload"
        >
          <el-tab-pane
            label="开放式及ETF(非QDII)基金"
            name="first"
          >
            <RankingOpenExcludeQDII
              ref="rankingOpenExcludeQDII"
              :categories="categories.open"
              :latestRatio="rankingRatio"
              @changeRankingRatio="setRankingRatio"
              v-show="showDailylyRankingDate"
            ></RankingOpenExcludeQDII>
            <RankingOpenExcludeQDIIMonthly
              ref="rankingOpenExcludeQDIIMonthly"
              :latestRatio="rankingRatio"
              :categories="categories.open"
              @changeRankingRatio="setRankingRatio"
              v-show="!showDailylyRankingDate"
            ></RankingOpenExcludeQDIIMonthly>
          </el-tab-pane>
          <el-tab-pane
            label="封闭式基金"
            name="second"
          >
            <RankingClose
              ref="rankingClose"
              :latestRatio="rankingRatio"
              :categories="categories.close"
              @changeRankingRatio="setRankingRatio"
              v-show="showDailylyRankingDate"
            ></RankingClose>
            <RankingCloseMonthly
              ref="rankingCloseMonthly"
              :latestRatio="rankingRatio"
              :categories="categories.close"
              @changeRankingRatio="setRankingRatio"
              v-show="!showDailylyRankingDate"
            ></RankingCloseMonthly>
          </el-tab-pane>
          <el-tab-pane
            label="QDII及海外基金"
            name="third"
          >
            <RankingQDIIOffShore
              ref="rankingQDIIOffShore"
              :latestRatio="rankingRatio"
              :categories="categories.qdII"
              @changeRankingRatio="setRankingRatio"
              v-show="showDailylyRankingDate"
            ></RankingQDIIOffShore>
            <RankingQDIIOffShoreMonthly
              ref="rankingQDIIOffShoreMonthly"
              :latestRatio="rankingRatio"
              :categories="categories.qdII"
              @changeRankingRatio="setRankingRatio"
              v-show="!showDailylyRankingDate"
            ></RankingQDIIOffShoreMonthly>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-raw v-show="!isShowRankingTab">
      <RankingSearch
        ref="rankingSearch"
        v-show="showDailylyRankingDate"
        :tempCompanyNameStr="tempCompanyNameStr"
      ></RankingSearch>
      <RankingSearchMonthly
        ref="rankingSearchMonthly"
        v-show="!showDailylyRankingDate"
        :tempCompanyNameStr="tempCompanyNameStr"
      ></RankingSearchMonthly>
    </el-raw>
    <br />
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import {
    rankDownload,
    getFundRank,
    getLatestDate,
    getMonthlyReportFixed,
    getSubscription,
    editSubscription,
    sendRankReportByEmail,
    getCategoryList,
    getSubscriptionMonthly,
    editSubscriptionMonthly,
    sendRankReportByEmailMonthly
} from "../api/ranking";
import RankingOpenExcludeQDII from "./RankingOpenExcludeQDII";
import RankingClose from "./RankingClose";
import RankingQDIIOffShore from "./RankingQDIIOffShore";
import RankingSearch from "./RankingSearch";
import XLSX from "xlsx";
import RankingOpenExcludeQDIIMonthly from "./RankingOpenExcludeQDIIMonthly";
import RankingCloseMonthly from "./RankingCloseMonthly";
import RankingQDIIOffShoreMonthly from "./RankingQDIIOffShoreMonthly";
import RankingSearchMonthly from "./RankingSearchMonthly";
import {
    getRankingExportColumnsByPage,
    getRankingExportMapSnapshot,
} from "./mixin/exportColumnMapHelper";

const componentsCommon = require("cb-components-common").default;
const checkResponseStatus = componentsCommon.common.checkResponseStatus;
const logout = componentsCommon.common.logout;
const getDisableExport = componentsCommon.common.getDisableExport;
const getRankingMemberBaseTrial = componentsCommon.common.getRankingMemberBaseTrial;
const getRankingMemberBase = componentsCommon.common.getRankingMemberBase;
const getRankingMemberSeniorTrial = componentsCommon.common.getRankingMemberSeniorTrial;
const getRankingMemberSenior = componentsCommon.common.getRankingMemberSenior;
const getNameAndValue = componentsCommon.localStorage.getNameAndValue;
const fetchFile = componentsCommon.downloadUtils.fetchFile;
const openDownloadDialog = componentsCommon.downloadUtils.openDownloadDialog;
const sheet2blob4Rank = componentsCommon.downloadUtils.sheet2blob4Rank;
const sheet2blob4RankMRF = componentsCommon.downloadUtils.sheet2blob4RankMRF;
const getCompanyList = componentsCommon.apiCommon.getCompanyList;
const getWorkDate = componentsCommon.apiCommon.getWorkDate;
const getFilter = componentsCommon.apiCommon.getFilter;
const searchBox = componentsCommon.mixin.searchBox.searchBox;
const exportFile = componentsCommon.mixin.exportFile.exportFile;
const componentsSuitability = require("cb-components-suitability").default;
const frequencyConfig =
    componentsSuitability.Suitability.components.LatestEvaluation.mixins[2];

export default {
    mixins: [exportFile, searchBox, RankingSearch, frequencyConfig],
    data() {
        let self =this;
        return {
            configResendNeeded: true,
            configResendNeededMonthly: true,
            selectFrequencyDaily: "daily",
            selectFrequencyMonthly: "monthly",
            configSendDialogVisible: false,
            configSendDialogVisibleMonthly: false,
            onceSendDialogVisible: false,
            exportOption: "currentList",
            exportVisible: false,
            rankingRatio: "",
            isShowRankingTab: true,
            searchPopoverVisible: false,
            symbolList: [],
            isShowCompanySelect: false,
            searchTypeSel: "",
            symbolInfo: "",
            symbol: [],
            symbolValue:"",
            activeName: "first",
            account: "",
            company: "",
            companyList: [],
            filteredCompanyList: [],
            curCompanyName:'' ,
            curCompanyNameMonthly:'' ,
            filteredCompanyListDaily: [],
            filteredCompanyListMonthly: [],
            tempCompanyNameStr: "",
            loading: false,
            dateValue: "",
            dateValueMonthly: "",
            disableExport: true,
            rankingType: "monthlyRanking",
            disableDailyRanking: true,
            disableMonthlyRanking: true,
            showDailylyRankingDate: true,
            showMonthlyRankingDate: true,
            monthlySignOff: true,
            monthlyLastUpdate: "",
            categories:{},
            timeList: [],
            latestDate: "",
            pickerOptions: {
                disabledDate(time) {
                    let year = time.getFullYear();
                    let month = time.getMonth() + 1;
                    let day = time.getDate();
                    let originDate =
                            year +
                            (month < 10 ? "-0" : "-") +
                            month +
                            (day < 10 ? "-0" : "-") +
                            day;
                    
                    if (self.timeList.includes(originDate)) {
                        return false;
                    } else{
                        return true;
                    }

                    // if (window.availableWorkDate) {
                    //     let year = time.getFullYear();
                    //     let month = time.getMonth() + 1;
                    //     let day = time.getDate();
                    //     let originDate =
                    //         year +
                    //         (month < 10 ? "-0" : "-") +
                    //         month +
                    //         (day < 10 ? "-0" : "-") +
                    //         day;
                    //     console.log("这是:"+originDate)
                    //     return (
                    //         window.availableWorkDate.indexOf(originDate) === -1
                    //     );
                    // }
                    // return false;
                },
                cellClassName(time) {
                    if (window.latestWorkDate) {
                        let tempDate = window.latestWorkDate.split("-");
                        let tempLatestWorkDate = new Date(
                            tempDate[0],
                            tempDate[1],
                            tempDate[2]
                        );
                        let tempMonth = time.getMonth();
                        if (tempMonth == 12) {
                            tempMonth = 1;
                        } else {
                            tempMonth = tempMonth + 1;
                        }

                        if (
                            tempLatestWorkDate.getFullYear() ==
                                time.getFullYear() &&
                            tempLatestWorkDate.getMonth() == tempMonth &&
                            tempLatestWorkDate.getDate() == time.getDate()
                        ) {
                            return "red";
                        }
                    }
                }
            },
            pickerOptionsMonthly: {
                disabledDate(time) {
                    let timeNow = new Date();
                    return (
                        time.getTime() > Date.now() - 8.64e7 || // 禁止未来
                        time.getTime() < (new Date("2020-06-30") - 8.64e7) || // 禁止2020-06-30前
                        (time.getFullYear() == timeNow.getFullYear() && time.getMonth() == timeNow.getMonth()) // 禁止本年本月
                    );
                }
            }
        };
    },
    watch: {
        activeName: function(val) {
            let self = this;
            this.reloadPage();
        },
        dateValue: function(val) {
            let self = this;
            //self.selectFundOrCompany("");
            this.reloadPage();
        },
        dateValueMonthly: function(val) {
            let self = this;
            if (val == null || val == "" || val == undefined) {
                self.setDateValueMonthlyToLastMonthendDateWhenItIsNull();
            }
            self.getMonthlySignOffInfo({ date: self.dateValueMonthly });
            self.getCategories();
        },
        company: function(val) {
            let self = this;
            for (let i = 0; i<self.filteredCompanyList.length;i++) {
                if (self.filteredCompanyList[i].companyId.includes(val)) {
                    self.tempCompanyNameStr = self.filteredCompanyList[i].companyName;
                    break;
                }
            }
            this.reloadPage();
        },
        rankingType: function(val) {
            let self = this;
            let userInfo = getNameAndValue("info");
            if (userInfo != undefined && userInfo != null && userInfo != "") {
                const user = JSON.parse(userInfo);
                if (val == "dailyRanking") {
                    self.showDailylyRankingDate = true;
                    self.showMonthlyRankingDate = false;

                    if(user.rankingMemberSeniorTrial)
                    {
                        // self.disableExport = getDisableExport()||getRankingMemberSeniorTrial();
                        if(getDisableExport() || user.rankingMemberSeniorTrial)
                        {
                            self.disableExport = true;
                        }
                        else
                        {
                            self.disableExport = false;
                        }                        
                    }
                    else{
                        self.disableExport = getDisableExport();
                    }
                } else {
                    self.showDailylyRankingDate = false;
                    self.showMonthlyRankingDate = true;

                    self.setDateValueMonthlyToLastMonthendDateWhenItIsNull();

                    if(user.rankingMemberBaseTrial)
                    {
                        // self.disableExport = getDisableExport()||getRankingMemberBaseTrial();
                        if(getDisableExport() || user.rankingMemberBaseTrial)
                        {
                            self.disableExport = true;
                        }
                        else
                        {
                            self.disableExport = false;
                        }
                    }
                    else{
                        self.disableExport = getDisableExport();
                    }
                }
            }

            self.getCategories();
        }
    },
    components: {
        RankingOpenExcludeQDII,
        RankingClose,
        RankingQDIIOffShore,
        RankingSearch,
        RankingOpenExcludeQDIIMonthly,
        RankingCloseMonthly,
        RankingQDIIOffShoreMonthly,
        RankingSearchMonthly
    },
    mounted() {
        let self = this;
        let userInfo = getNameAndValue("info");

        let businessDate = null;
        getWorkDate({ limit: 5, skip: 0 })
                .then(response => {
                    let result = response.data;
                    if (result != undefined) {				
					    businessDate = response.data.data;
					}
                    if(businessDate != null){ 
                        let specialDateAdded = false; // 标志变量，记录是否已添加特殊日期                  
                        for (let i = 0; i < businessDate.length; i++) {
                                let localtime = new Date();
                                let localDay = self.getDayStr(localtime);
                                let minDate = businessDate[businessDate.length - 1];
                                let maxDate = localDay;
                                
                                let year = new Date(localDay);
                                let yeardata = year.getFullYear();
                                let targetDate1 = yeardata + '-12-31';
                                let targetDate2 = yeardata + '-06-30';
                                
                                //通过getWorkDate接口获取五个交易日，如果6/30或12/31在最大和最小日期内，则标记插入日期（只标记插入一次）
                                if (!specialDateAdded) {
                                    let isSpecialDate1InRange = (new Date(targetDate1) > new Date(minDate)) && (new Date(targetDate1) < new Date(maxDate));
                                    let isSpecialDate2InRange = (new Date(targetDate2) > new Date(minDate)) && (new Date(targetDate2) < new Date(maxDate));
                                    if (isSpecialDate1InRange) {
                                        self.timeList.push(targetDate1);
                                        specialDateAdded = true; // 设置标志变量为 true，表示已添加过特殊日期
                                    }
                                    if (isSpecialDate2InRange) {
                                        self.timeList.push(targetDate2);
                                        specialDateAdded = true; 
                                    }
                                }
                                self.timeList.push(businessDate[i]);
                            }                               
                            self.timeList.sort();  
                            if (self.timeList.length == 6) {
                                self.timeList.shift();
                            } 
                        }
                });
        
        getLatestDate()
                .then(response => {
                    let result = response.data;
                    if (result != undefined) {
                        let data = response.data.data;
                        this.latestDate = data;
                    }
                });

        // //当日没有数据时，k=8，j=1
        // let k=8;
        // let j=1;
        // let nowDate = new Date(new Date().getTime());
        // let now = self.getDayStr(nowDate);
        // if (now == this.latestDate) {
        //     k=7;
        //     j=0;
        // } else {
        //     k=8;
        //     j=1;
        // }

        // for (let i=k;i>=j;i--) {
        //     let dd = new Date(new Date().getTime()-3600*1000*24*i);
        //     let originDate1 = self.getDayStr(dd);
        //     let week = self.getWeekDay(dd);
        //     if (week != '周六' && week != '周日' && originDate1 != '2023-01-23' && originDate1 != '2023-01-24' && originDate1 != '2023-01-25'
        //     && originDate1 != '2023-10-02' && originDate1 != '2023-10-03' && originDate1 != '2023-10-04' && originDate1 != '2023-10-05' && originDate1 != '2023-10-06') {
        //         self.timeList.push(originDate1);
        //     }
        // }

        // //判断显示日期中是否包含月末最后一天，是则判断是否是周六日，是则可点击
        // let endDateStr = new Date(new Date().getTime()-3600*1000*24*7);
        // let lastDays = new Date(endDateStr.getFullYear(),endDateStr.getMonth()+1,0);

        // //先判断列表中是否包含有最后一天，是才判断
        // if (self.timeList.concat(self.getDayStr(lastDays))) {
        //     if (self.getWeekDay(lastDays) == '周六' || self.getWeekDay(lastDays) == '周日') {
        //         let endStr = self.getDayStr(lastDays);
        //         self.timeList.push(endStr);
        //     }
        // }

        if (userInfo != undefined && userInfo != null && userInfo != "") {
            const user = JSON.parse(userInfo);
            self.account = user.email;

            if (user.ranking == 1) {   
                //retrieve ranking menu list from server
                self.getCategories();

                if ((user.rankingMemberBaseTrial || user.rankingMemberBase) && !user.rankingMemberSeniorTrial && !user.rankingMemberSenior) {
                    self.rankingType = "monthlyRanking";
                    self.disableDailyRanking = true;
                    self.disableMonthlyRanking = false;

                    self.showDailylyRankingDate = false;
                    self.showMonthlyRankingDate = true;

                    if(user.rankingMemberBaseTrial)
                    {                        
                        if(getDisableExport() || user.rankingMemberBaseTrial)
                        {
                            this.disableExport = true;
                        }
                        else
                        {
                            this.disableExport = false;
                        }
                    }
                    else{
                        this.disableExport = getDisableExport();
                    }
                }

                if (!user.rankingMemberBaseTrial && !user.rankingMemberBase && (user.rankingMemberSeniorTrial || user.rankingMemberSenior)) {
                    self.rankingType = "dailyRanking";   

                    self.disableDailyRanking = false;
                    self.disableMonthlyRanking = true;

                    self.showDailylyRankingDate = true;
                    self.showMonthlyRankingDate = false;

                    if(user.rankingMemberSeniorTrial)
                    {                        
                        if(getDisableExport() || user.rankingMemberSeniorTrial)
                        {
                            this.disableExport = true;
                        }
                        else
                        {
                            this.disableExport = false;
                        }
                    }
                    else{
                        this.disableExport = getDisableExport();
                    }
                }

                if ((user.rankingMemberBaseTrial || user.rankingMemberBase) && (user.rankingMemberSeniorTrial ||user.rankingMemberSenior)) {
                    self.rankingType = "dailyRanking";
                    self.disableDailyRanking = false;
                    self.disableMonthlyRanking = false;

                    self.showDailylyRankingDate = true;
                    self.showMonthlyRankingDate = false;

                    if(user.rankingMemberSeniorTrial)
                    {                        
                        if(getDisableExport() || user.rankingMemberSeniorTrial)
                        {
                            this.disableExport = true;
                        }
                        else
                        {
                            this.disableExport = false;
                        }
                    }
                    else{
                        this.disableExport = getDisableExport();
                    }
                }
            }
        } else {
            logout(self);       
        }        

        if (self.activeName == "first") {
            if (self.showDailylyRankingDate) {
                self.$refs.rankingOpenExcludeQDII.loadingData(
                    self.$refs.rankingOpenExcludeQDII.length > 0 ? self.$refs.rankingOpenExcludeQDII[0].categories[0].id : "PGSZ01TTTT" , //普通股票型
                    self.company,
                    self.showDailylyRankingDate
                        ? self.dateValue
                        : self.dateValueMonthly
                );
            } else {
                self.$refs.rankingOpenExcludeQDIIMonthly.loadingData(
                    self.$refs.rankingOpenExcludeQDIIMonthly.length > 0 ? self.$refs.rankingOpenExcludeQDIIMonthly[0].categories[0].id :"PGSZ01TTTT", //普通股票型
                    self.company,
                    self.showDailylyRankingDate
                        ? self.dateValue
                        : self.dateValueMonthly
                );
            }
        }

        self.handleCompany();
        self.getWorkDateFun({ limit: 5, skip: 0 });
    },
    methods: {
        getExportPageName(showDailyRankingDate, activeName) {
            if (showDailyRankingDate) {
                switch (activeName) {
                    case "first":
                        return "RankingOpenExcludeQDII";
                    case "second":
                        return "RankingClose";
                    case "third":
                        return "RankingQDIIOffShore";
                    default:
                        return "RankingSearch";
                }
            }

            switch (activeName) {
                case "first":
                    return "RankingOpenExcludeQDIIMonthly";
                case "second":
                    return "RankingCloseMonthly";
                case "third":
                    return "RankingQDIIOffShoreMonthly";
                default:
                    return "RankingSearchMonthly";
            }
        },
        getFullListTemplatePageName(showDailyRankingDate, isMRFSheet) {
            if (showDailyRankingDate) {
                return isMRFSheet ? "RankingQDIIOffShore" : "RankingOpenExcludeQDII";
            }
            return isMRFSheet ? "RankingQDIIOffShoreMonthly" : "RankingOpenExcludeQDIIMonthly";
        },
        getCurrentListRefByActiveName(showDailyRankingDate, activeName) {
            if (showDailyRankingDate) {
                switch (activeName) {
                    case "first": return this.$refs.rankingOpenExcludeQDII;
                    case "second": return this.$refs.rankingClose;
                    case "third": return this.$refs.rankingQDIIOffShore;
                    default: return this.$refs.rankingSearch;
                }
            }
            switch (activeName) {
                case "first": return this.$refs.rankingOpenExcludeQDIIMonthly;
                case "second": return this.$refs.rankingCloseMonthly;
                case "third": return this.$refs.rankingQDIIOffShoreMonthly;
                default: return this.$refs.rankingSearchMonthly;
            }
        },
        getExportColumnsFromRef(ref) {
            if (!ref) return [];
            const methodNames = [
                'getRankingOpenExcludeQDIIExportColumnMap',
                'getRankingOpenExcludeQDIIMonthlyExportColumnMap',
                'getRankingCloseExportColumnMap',
                'getRankingCloseMonthlyExportColumnMap',
                'getRankingQDIIOffShoreExportColumnMap',
                'getRankingQDIIOffShoreMonthlyExportColumnMap',
                'getRankingSearchExportColumnMap',
                'getRankingSearchMonthlyExportColumnMap',
            ];
            for (const name of methodNames) {
                if (typeof ref[name] === 'function') {
                    return ref[name]();
                }
            }
            return [];
        },
        buildMRFExportColumns(showDailyRankingDate, showWithinYearRank) {
            const columns = [
                { label: "基金代码", field: "defaultSymbol", valuePath: "scope.row.defaultSymbol" },
                { label: "基金名称", field: "legalName", valuePath: "scope.row.legalName" },
                { label: "基金类型", field: "categoryName", valuePath: "scope.row.categoryName" },
                { label: "成立日期", field: "inceptionDate", valuePath: "scope.row.inceptionDate" },
                { label: "晨星评级|三年评级", field: "starRating3", valuePath: "scope.row.starRating3" },
                { label: "晨星评级|五年评级", field: "starRating5", valuePath: "scope.row.starRating5" },
                { label: "晨星评级|十年评级", field: "starRating10", valuePath: "scope.row.starRating10" },
            ];

            if (showDailyRankingDate) {
                columns.push({ label: "最新净值|日期", field: "priceDate", valuePath: "scope.row.priceDate" });
                columns.push({ label: "单位净值|(元)", field: "nav", valuePath: "scope.row.nav" });
                columns.push({ label: "日回报|总回报率", field: "return1Day", valuePath: "scope.row.return1Day" });
            } else {
                columns.push({ label: "净值日期", field: "priceDate", valuePath: "scope.row.priceDate" });
                columns.push({ label: "单位净值|(元)", field: "nav", valuePath: "scope.row.nav" });
            }

            const withinYearPeriods = [
                { group: "今年以来", returnField: "returnYTD", rankField: "returnYTDRank", absoluteField: "absolute1YRank", percentileField: "percentileM0Rank" },
                { group: "最近一周", returnField: "return1Week", rankField: "return1WeekRank", absoluteField: "absolute1YRank", percentileField: "percentile1WRank" },
                { group: "最近一月", returnField: "return1Month", rankField: "return1MonthRank", absoluteField: "absolute1YRank", percentileField: "percentile1MRank" },
                { group: "最近三月", returnField: "return3Month", rankField: "return3MonthRank", absoluteField: "absolute1YRank", percentileField: "percentile3MRank" },
                { group: "最近六月", returnField: "return6Month", rankField: "return6MonthRank", absoluteField: "absolute1YRank", percentileField: "percentile6MRank" },
            ];

            const beyondYearPeriods = [
                { group: "最近一年", returnField: "return1Year", rankField: "return1YearRank", absoluteField: "absolute1YRank", percentileField: "percentile1YRank" },
            ];

            const longTermPeriods = [
                { group: "最近两年", returnField: "return2Year", accField: "accReturn2Year", rankField: "return2YearRank", absoluteField: "absolute2YRank", percentileField: "percentile2YRank" },
                { group: "最近三年", returnField: "return3Year", accField: "accReturn3Year", rankField: "return3YearRank", absoluteField: "absolute3YRank", percentileField: "percentile3YRank" },
                { group: "最近五年", returnField: "return5Year", accField: "accReturn5Year", rankField: "return5YearRank", absoluteField: "absolute5YRank", percentileField: "percentile5YRank" },
                { group: "最近七年", returnField: "return7Year", accField: "accReturn7Year", rankField: "return7YearRank", absoluteField: "absolute7YRank", percentileField: "percentile7YRank" },
                { group: "最近十年", returnField: "return10Year", accField: "accReturn10Year", rankField: "return10YearRank", absoluteField: "absolute10YRank", percentileField: "percentile10YRank" },
                { group: "最近十五年", returnField: "return15Year", accField: "accReturn15Year", rankField: "return15YearRank", absoluteField: "absolute15YRank", percentileField: "percentile15YRank" },
            ];

            // 北上基金导出差异：日榜仅导出同类百分比排名；月榜导出同类排名+同类百分比排名。
            const includeAbsoluteRank = !showDailyRankingDate;

            const addPeriod = (p, needWithinYearCheck) => {
                columns.push({ label: p.group + "|总回报率", field: p.returnField, valuePath: "scope.row." + p.returnField });
                if (needWithinYearCheck && !showWithinYearRank) return;
                if (includeAbsoluteRank) {
                    columns.push({ label: p.group + "|同类排名", field: p.absoluteField, valuePath: "scope.row." + p.absoluteField });
                }
                columns.push({ label: p.group + "|同类百分比排名", field: p.percentileField, valuePath: "scope.row." + p.percentileField });
            };

            const addLongTermPeriod = (p) => {
                columns.push({ label: p.group + "|年化回报率", field: p.returnField, valuePath: "scope.row." + p.returnField });
                columns.push({ label: p.group + "|总回报率", field: p.accField, valuePath: "scope.row." + p.accField });
                if (includeAbsoluteRank) {
                    columns.push({ label: p.group + "|同类排名", field: p.absoluteField, valuePath: "scope.row." + p.absoluteField });
                }
                columns.push({ label: p.group + "|同类百分比排名", field: p.percentileField, valuePath: "scope.row." + p.percentileField });
            };

            withinYearPeriods.forEach(p => addPeriod(p, !showDailyRankingDate));
            beyondYearPeriods.forEach(p => addPeriod(p, false));
            longTermPeriods.forEach(p => addLongTermPeriod(p));

            columns.push({ label: "成立以来|总回报率", field: "returnInception", valuePath: "scope.row.returnInception" });
            columns.push({ label: "晨星分类", field: "categoryNameLocal", valuePath: "scope.row.categoryNameLocal" });
            columns.push({ label: "晨星分类组别", field: "categoryGroupName", valuePath: "scope.row.categoryGroupName" });
            columns.push({ label: "晨星资产大类", field: "broadCategoryName_CN", valuePath: "scope.row.broadCategoryName_CN" });
            columns.push({ label: "是否最早份额", field: "ifOldestShare", valuePath: "scope.row.ifOldestShare" });
            columns.push({ label: "是否转型基金", field: "ifPeerGroupMembershipChange", valuePath: "scope.row.ifPeerGroupMembershipChange" });

            return columns;
        },
        getMonthlyWithinYearRankState() {
            if (this.showDailylyRankingDate) {
                return false;
            }

            if (!this.isShowRankingTab) {
                return (this.$refs.rankingSearchMonthly && this.$refs.rankingSearchMonthly.showWithinYearRank) || false;
            }

            switch (this.activeName) {
                case "first":
                    return (this.$refs.rankingOpenExcludeQDIIMonthly && this.$refs.rankingOpenExcludeQDIIMonthly.showWithinYearRank) || false;
                case "third":
                    return (this.$refs.rankingQDIIOffShoreMonthly && this.$refs.rankingQDIIOffShoreMonthly.showWithinYearRank) || false;
                default:
                    return false;
            }
        },
        getExportColumnsByMode({ showDailyRankingDate, exportOption, activeName, isMRFSheet }) {
            if (exportOption === "currentList") {
                const ref = this.getCurrentListRefByActiveName(showDailyRankingDate, activeName);
                const columnsFromRef = this.getExportColumnsFromRef(ref);
                if (columnsFromRef.length > 0) {
                    return columnsFromRef;
                }
                const pageName = this.getExportPageName(showDailyRankingDate, activeName);
                if (!pageName) return [];
                return this.getResolvedExportColumns(pageName);
            }

            if (isMRFSheet) {
                const showWithinYearRank = !showDailyRankingDate
                    ? this.getMonthlyWithinYearRankState()
                    : true;
                return this.buildMRFExportColumns(showDailyRankingDate, showWithinYearRank);
            }

            if (!showDailyRankingDate && this.$refs.rankingOpenExcludeQDIIMonthly && typeof this.$refs.rankingOpenExcludeQDIIMonthly.getRankingOpenExcludeQDIIMonthlyExportColumnMap === "function") {
                return this.$refs.rankingOpenExcludeQDIIMonthly.getRankingOpenExcludeQDIIMonthlyExportColumnMap(this.getMonthlyWithinYearRankState());
            }

            const nonMrfRef = showDailyRankingDate
                ? this.$refs.rankingOpenExcludeQDII
                : this.$refs.rankingOpenExcludeQDIIMonthly;
            const columnsFromRef = this.getExportColumnsFromRef(nonMrfRef);
            if (columnsFromRef.length > 0) {
                return columnsFromRef;
            }
            const pageName = this.getFullListTemplatePageName(showDailyRankingDate, false);
            return this.getResolvedExportColumns(pageName);
        },
        getHeaderByColumnLabel(label) {
            if (label == null) {
                return "";
            }
            return String(label).replace(/\|/g, "");
        },
        normalizeExportColumns(columns) {
            const sourceColumns = Array.isArray(columns) ? columns : [];
            const normalized = sourceColumns.map((item) => ({
                label: item.label,
                field: item.field,
                valuePath: item.valuePath,
            }));

            const hasCategoryName = normalized.some((item) => item.field === "categoryName");
            if (!hasCategoryName) {
                normalized.splice(2, 0, {
                    label: "基金类型",
                    field: "categoryName",
                    valuePath: "scope.row.categoryName",
                });
            }

            return normalized;
        },
        getExportCellValue(row, field) {
            if (field === "inceptionDate" || field === "priceDate") {
                const dateValue = row[field] == null ? "" : row[field];
                return this.formatDate(dateValue == null ? "" : String(dateValue));
            }

            if (field === "ifOldestShare" || field === "ifPeerGroupMembershipChange") {
                return row[field] === true || row[field] === "true"
                    ? "是"
                    : row[field] === false || row[field] === "false"
                    ? "否"
                    : "--";
            }

            const value = row[field];
            if (value === undefined || value === null || value === "null/null") {
                return "";
            }
            return value;
        },
        buildExportMatrix(columns, dataRows) {
            const normalizedColumns = this.normalizeExportColumns(columns);
            const headers = normalizedColumns.map((item) => this.getHeaderByColumnLabel(item.label));
            const matrix = [headers];

            (Array.isArray(dataRows) ? dataRows : []).forEach((row) => {
                if (!row || !row.defaultSymbol) {
                    return;
                }

                const values = normalizedColumns.map((item) => this.getExportCellValue(row, item.field));
                matrix.push(values);
            });

            return matrix;
        },
        getResolvedExportColumns(pageName) {
            return getRankingExportColumnsByPage(pageName, getNameAndValue);
        },
        getResolvedExportMapSnapshot() {
            return getRankingExportMapSnapshot(getNameAndValue);
        },
        getDayStr(date) {
            let dy = date.getFullYear();
            let dm = date.getMonth() + 1;
            let da = date.getDate();
            let originDate =
                dy +
                (dm < 10 ? "-0" : "-") +
                dm +
                (da < 10 ? "-0" : "-") +
                da;
            return originDate;
        },
        getWeekDay(date) {
				var week;
				if(date.getDay()==0) week="周日"
				if(date.getDay()==1) week="周一"
				if(date.getDay()==2) week="周二"
				if(date.getDay()==3) week="周三"
				if(date.getDay()==4) week="周四"
				if(date.getDay()==5) week="周五"
				if(date.getDay()==6) week="周六"
				return week;
		},
        submitSearch() {
            let self = this;
            self.reloadPage();
        },
        setRankingRatio(value) {
            let self = this;
            self.rankingRatio = value;
        },
        searchDataByAutoComplete(queryString, that) {
            const self = this;
            let results = self.symbolList;
            self.state.length = 0;
            self.state.push(
                "<span class='searchbox_symbol font_bold'>基金代码</span><span class='searchbox_title font_bold'>基金名称</span>"
            );
            if (results !== undefined) {
                for (let i = 0; i < results.length; i++) {
                    const value = results[i].symbol + "    " + results[i].name;
                    let htmlString = value.replace(
                        queryString,
                        "<b style='color:red;'>" + queryString + "</b>"
                    );
                    htmlString = htmlString.replace(
                        "    ",
                        "</span><span class='searchbox_title'>"
                    );
                    if (i === 0) {
                        self.firstSymbol = results[i].symbol;
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                                htmlString +
                                "</span>"
                        );
                    } else {
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                                htmlString +
                                "</span>"
                        );
                    }
                }
            }
            if (results === undefined || results.length === 0) {
                self.state.length = 0;
                self.state.push(
                    "<span class='font_bold'>抱歉，没有找到和" +
                        "<b style='color:red;'>" +
                        queryString +
                        "</b>" +
                        "相关的内容</span>"
                );
            }
            self.$refs.search_scrollbar.update();
            //self.$refs.searchPopover.updatePopper();
        },
        getFundInformation(symbolValue) {
            let self = this;
            let symbolInfo = [];
            if (
                symbolValue.indexOf("</span><span class='searchbox_title'>") >
                -1
            ) {
                self.searchPopoverVisible = false;
                symbolInfo = symbolValue.split(
                    "</span><span class='searchbox_title'>"
                );

                symbolValue = symbolInfo[0];
                symbolValue = symbolValue
                    .replace("<b style='color:red;'>", "")
                    .replace("<span class='searchbox_symbol'>", "")
                    .replace("</b>", "");
            }

            if (!isNaN(Number(symbolValue))) {
                let symbolName = symbolInfo[1]
                    .replace("</span>", "")
                    .replace("<b style='color:red;'>", "")
                    .replace("</b>", "");
                self.symbolInfo = symbolValue + " " + symbolName;
                self.symbol = new Array();
                self.symbol[0] = symbolValue;
                self.symbol[1] = symbolName;
                self.isShowRankingTab = false;
                if (self.showDailylyRankingDate) {
                    self.$refs.rankingSearch.loadingData(
                        "",
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly,
                        self.isShowRankingTab,
                        symbolValue + "_" + symbolName
                    );
                } else {
                    self.$refs.rankingSearchMonthly.loadingData(
                        "",
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly,
                        self.isShowRankingTab,
                        symbolValue + "_" + symbolName
                    );
                }
                self.symbolValue = symbolValue;
            }
        },
        selectFundOrCompany(value) {
            let self = this;
            if (value === "selectCompany") {
                self.isShowCompanySelect = true;
                self.searchPopoverVisible = false;
                self.symbolInfo = "";
                self.activeName = "";
            }
            if (value === "selectFund") {
                self.isShowCompanySelect = false;
                self.company = "";
                self.activeName = "";
            }
            if (value === "") {
                self.activeName = "first";
                self.company = "";
                self.symbolInfo = "";
                self.searchTypeSel = "";
                self.symbol = "";
                self.isShowRankingTab = true;
            }
        },
        logoutAccount() {
            let self = this;
            logout(self);
        },
        backHome() {
            let self = this;
            /*
            self.$router.push({
                path: "/home"
            });
            */
            self.$router.go(-1);
        },
        latestReload(para) {
            let self = this;
            if (para.name == "first") {
                if (self.showDailylyRankingDate) {
                    self.$refs.rankingOpenExcludeQDII.loadingData(
                        self.$refs.rankingOpenExcludeQDII.categories.length > 0 ? self.$refs.rankingOpenExcludeQDII.categories[0].categories[0].id : "PGSZ01TTTT", //普通股票型
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly,
                        0    
                    );
                } else {
                    self.$refs.rankingOpenExcludeQDIIMonthly.loadingData(
                        self.$refs.rankingOpenExcludeQDIIMonthly.categories.length > 0 ? self.$refs.rankingOpenExcludeQDIIMonthly.categories[0].categories[0].id : "PGSZ01TTTT", //普通股票型
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly,
                        0
                        
                    );
                }
            }
        },
        
        getCategories() {
            const self = this;
            self.loading = true;
            let param = {};
            if(self.rankingType == 'monthlyRanking') {
                param.date=self.dateValueMonthly;
            } 
            if (param.date == null) {
                param.date = "";
            }


            getCategoryList(param)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            self.categories = result.data;
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.reloadPage();
                    self.loading = false;
                });
        },
        handleCompany() {
            const self = this;
            getCompanyList()
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                self.companyList = self.filteredCompanyList = self.filteredCompanyListDaily = self.filteredCompanyListMonthly = result.data.companyList;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        fiterCompany(query) {
            let self = this;
            if (query !== "") {
                this.filteredCompanyList = this.companyList.filter(item => {
                    return (
                      ( item.companyNamePhonetic !=null && item.companyName !=null ) 
                      &&
                      ( item.companyNamePhonetic
                            .toLowerCase()
                            .indexOf(query.toLowerCase()) > -1 ||
                        item.companyName.indexOf(query) > -1 )
                    );
                });
            } else {
                this.filteredCompanyList = this.companyList;
            }
        },
        reloadPage() {
            let self = this;
            let keyword = "";
            if (Array.isArray(self.symbol) && self.symbol.length > 1) {
                keyword = self.symbol[0] + "_" + self.symbol[1];
            } else if (self.symbolInfo != null && self.symbolInfo != "") {
                keyword = self.symbolInfo;
            }
            if(self.company == ""){
                self.filteredCompanyList = self.companyList;
            }

            if (!self.isShowRankingTab) {
                if (self.showDailylyRankingDate) {
                    self.$refs.rankingSearch.loadingData(
                        "",
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly,
                        self.isShowRankingTab,
                        keyword
                    );
                } else {
                    self.$refs.rankingSearchMonthly.loadingData(
                        "",
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly,
                        self.isShowRankingTab,
                        keyword
                    );
                }
                return;
            }

            if (self.showDailylyRankingDate) {
                switch (self.activeName) {
                    case "first":
                        if(self.symbolInfo != null && self.symbolInfo != "") {
                                self.$refs.rankingSearch.loadingData(
                                "",
                                self.symbolValue,
                                self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                                self.isShowRankingTab,
                                ""
                            );
                        } else {
                            self.$refs.rankingOpenExcludeQDII.loadingData(
                            self.$refs.rankingOpenExcludeQDII.categories.length > 0 ? self.$refs.rankingOpenExcludeQDII.categories[0].categories[0].id : "PGSZ01TTTT", //普通股票型
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                                0
                            );
                        }
                        break;
                    case "second":
                        self.$refs.rankingClose.loadingData(
                            self.$refs.rankingClose.categories.length > 0 ? self.$refs.rankingClose.categories[0].categories[0].id : "PGSZ01TTTT", //普通股票型
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                                0
                        );
                        break;
                    case "third":
                        self.$refs.rankingQDIIOffShore.loadingData(
                            self.$refs.rankingQDIIOffShore.categories.length > 0 ? self.$refs.rankingQDIIOffShore.categories[0].categories[0].id : "EUCA000501", //亚太区不包括日本
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                                0
                        );
                        break;
                    default:
                        self.isShowRankingTab = false;
                        self.$refs.rankingSearch.loadingData(
                            "",
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                            self.isShowRankingTab,
                            keyword
                        );
                        break;
                }
            } else {
                switch (self.activeName) {
                    case "first":
                        if(self.symbolInfo != null && self.symbolInfo != "") {
                            self.$refs.rankingSearchMonthly.loadingData(
                            "",
                            self.symbolValue,
                            self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly,
                            self.isShowRankingTab,
                            ""
                        );
                        } else {
                            self.$refs.rankingOpenExcludeQDIIMonthly.loadingData(
                            self.$refs.rankingOpenExcludeQDIIMonthly.categories.length > 0 ? self.$refs.rankingOpenExcludeQDIIMonthly.categories[0].categories[0].id : "PGSZ01TTTT", //普通股票型
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                                0
                        );
                        }
                        break;
                    case "second":
                        self.$refs.rankingCloseMonthly.loadingData(
                            self.$refs.rankingCloseMonthly.categories.length > 0 ? self.$refs.rankingCloseMonthly.categories[0].categories[0].id : "PGSZ01TTTT", //普通股票型
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                                0
                        );
                        break;
                    case "third":
                        self.$refs.rankingQDIIOffShoreMonthly.loadingData(
                            self.$refs.rankingQDIIOffShoreMonthly.categories.length > 0 ? self.$refs.rankingQDIIOffShoreMonthly.categories[0].categories[0].id : "EUCA000501", //亚太区不包括日本
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                                0
                        );
                        break;
                    default:
                        self.isShowRankingTab = false;
                        self.$refs.rankingSearchMonthly.loadingData(
                            "",
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                            self.isShowRankingTab,
                            keyword
                        );
                        break;
                }
            }
        },
        downloadFile() {
            let self = this;
            let name = "";
            let tempType = "";
            switch (self.activeName) {
                case "first":
                    name = "晨星中国开放式及ETF基金排行榜";
                    tempType = "openEnd";
                    break;
                case "second":
                    name = "晨星中国封闭式基金业绩报告";
                    tempType = "closeEnd";
                    break;
                case "third":
                    name = "晨星中国QDII及海外基金排行榜";
                    tempType = "qDII";
                    break;
                default:
                    name = "晨星中国开放式及ETF基金排行榜";
                    tempType = "openEnd";
                    break;
            }
            let data = {
                type: tempType,
                date: self.dateValue
            };

            let fileName = name + ".xlsx";
            let fileType = "application/octet-stream;charset=utf-8";
            self.loading = true;
            rankDownload(data)
                .then(response => {
                    let data = response.data;
                    if (response.status == 200) {
                        fetchFile(data, fileType, fileName);
                    }
                    self.loading = false;
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        exportList() {
            let self = this;
            self.exportVisible = false;
            let params = {};
            let fileName = "";
            if(self.symbolInfo != ""){
                self.activeName = "";
            }
            if (self.showDailylyRankingDate) {
                if (self.exportOption == "currentList") {
                    fileName = "当前列表（日榜）";
                    switch (self.activeName) {
                        case "first":
                            params = self.$refs.rankingOpenExcludeQDII.params;
                            params.limit =
                                self.$refs.rankingOpenExcludeQDII.pagination.count;
                            break;
                        case "second":
                            params = self.$refs.rankingClose.params;
                            params.limit =
                                self.$refs.rankingClose.pagination.count;
                            break;
                        case "third":
                            params = self.$refs.rankingQDIIOffShore.params;
                            params.limit =
                                self.$refs.rankingQDIIOffShore.pagination.count;
                            break;
                        default:
                            params = self.$refs.rankingSearch.params;
                            params.limit =
                                self.$refs.rankingSearch.pagination.count;
                            break;
                    }
                } else {
                    fileName = "所有基金列表（日榜）";
                    params = {
                        type: "",
                        category: "", //"EquityFunds",
                        categoryId: "",
                        keyword: "",
                        date: self.dateValue, //"2020-06-30",
                        month: "", //"2020-06-30",
                        quarter: "", //"2020-06-30",
                        sort: "PriceDate",
                        order: "desc",
                        limit: 99999,
                        skip: 0,
                        page: 1
                    };
                }
            } else {
                if (self.exportOption == "currentList") {
                    fileName = "当前列表（月榜）";
                    switch (self.activeName) {
                        case "first":
                            params =
                                self.$refs.rankingOpenExcludeQDIIMonthly.params;
                            params.limit =
                                self.$refs.rankingOpenExcludeQDIIMonthly.pagination.count;
                            break;
                        case "second":
                            params = self.$refs.rankingCloseMonthly.params;
                            params.limit =
                                self.$refs.rankingCloseMonthly.pagination.count;
                            break;
                        case "third":
                            params =
                                self.$refs.rankingQDIIOffShoreMonthly.params;
                            params.limit =
                                self.$refs.rankingQDIIOffShoreMonthly.pagination.count;
                            break;
                        default:
                            params = self.$refs.rankingSearchMonthly.params;
                            params.limit =
                                self.$refs.rankingSearchMonthly.pagination.count;
                            break;
                    }
                } else {
                    fileName = "所有基金列表（月榜）";
                    params = {
                        type: "",
                        category: "", //"EquityFunds",
                        categoryId: "",
                        keyword: "",
                        date: self.dateValueMonthly, //"2020-06-30",
                        month: "", //"2020-06-30",
                        quarter: "", //"2020-06-30",
                        sort: "PriceDate",
                        order: "desc",
                        limit: 99999,
                        skip: 0,
                        page: 1
                    };
                }
            }
            self.loading = true;
            getFundRank(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                let fundList = result.data.rankInfo;
                                let mrfFlag = false;
                                if (fundList.length > 0) {
                                    mrfFlag = fundList[0].mrfofNorth == 1;
                                } 
                                fundList.sort(
                                    (a, b) => a.defaultSymbol - b.defaultSymbol
                                );
                                let fundListMRF = [];
                                if(self.exportOption == "fullList") {
                                    fundList = fundList.filter(fund => {
                                        if (fund.mrfofNorth == 1) {
                                            fundListMRF.push(fund);
                                            return false;
                                        }
                                        return true;
                                    });
                                }
                                var exportData;
                                var exportDataMRF;
                                const exportColumns = self.getExportColumnsByMode({
                                    showDailyRankingDate: self.showDailylyRankingDate,
                                    exportOption: self.exportOption,
                                    activeName: self.activeName,
                                    isMRFSheet: false,
                                });

                                if (self.exportOption == "currentList") {
                                    exportData = self.buildExportMatrix(exportColumns, fundList);
                                } else {
                                    const exportColumnsMRF = self.getExportColumnsByMode({
                                        showDailyRankingDate: self.showDailylyRankingDate,
                                        exportOption: self.exportOption,
                                        activeName: self.activeName,
                                        isMRFSheet: true,
                                    });
                                    exportData = self.buildExportMatrix(exportColumns, fundList);
                                    exportDataMRF = self.buildExportMatrix(exportColumnsMRF, fundListMRF);
                                }

                                /*
                                Legacy hard-coded export templates are temporarily disabled.
                                Keeping old implementation here for rollback during transition.
                                //导出排行榜日榜月榜逻辑：之前的逻辑是所有的数据都在一个excel里面，所以之前的做法是有新的数据列直接把数据列加进来。没有的话就是空（这种做法我认为合理也比较，也比较简单）。但是
                                //北上基金需求要求对这一类基金改动的数据重新放到一个sheet里面（CHBU-1339）,非北上基金类型导出不允许有新增的列，否则就会导致空值很多。日榜月榜导出当前页面导出，全量基金导出都会有影响。
                                //我的做法是：1：在接口传一个值mrf_N判断是否为北上基金（为true是北上）这样可以作为依据来判断当前页面的title显示和数据列。2：全量基金：根据self.exportOption能够判断出是导出全量基金数据列还是当前选择列表的
                                //数据列，先把非北上基金的数据放到fundList里面（根据self.exportOption做过滤，非北上基金数据放到fundListMRF里面）然后就去跑相应的excel模板
                                if(self.exportOption == "currentList") {
                                    if (self.showDailylyRankingDate) {
                                    exportData = [
                                        [
                                            "基金代码",
                                            "基金名称",
                                            "基金类型",
                                            "成立日期",
                                            "晨星评级（三年）",
                                            "晨星评级（五年）",
                                            "晨星评级（十年）",
                                            "最新净值日期",
                                            "单位净值（元）",
                                            "日回报率（%）",
                                            "今年以来总回报率（%）",
                                            // "今年以来同类排名",
                                            mrfFlag ? "今年以来同类百分比排名" : "今年以来同类排名",
                                            "最近一周总回报率（%）",
                                            // "最近一周同类排名",
                                            mrfFlag ? "最近一周同类百分比排名" : "最近一周同类排名",
                                            "最近一月总回报率（%）",
                                            // "最近一月同类排名",
                                            // "最近一月同类百分比排名" ,
                                            mrfFlag ? "最近一月同类百分比排名" : "最近一月同类排名",
                                            "最近三月总回报率（%）",
                                            // "最近三月同类排名",
                                            // "最近三月同类百分比排名",
                                            mrfFlag ? "最近三月同类百分比排名" : "最近三月同类排名",
                                            "最近六月总回报率（%）",
                                            // "最近六月同类排名",
                                            // "最近六月同类百分比排名",
                                            mrfFlag ? "最近六月同类百分比排名" : "最近六月同类排名",
                                            "最近一年总回报率（%）",
                                            // "最近一年同类排名",
                                            // "最近一年同类百分比排名",
                                            mrfFlag ? "最近一年同类百分比排名" : "最近一年同类排名",
                                            "最近两年年化回报率（%）",
                                            "最近两年总回报率（%）",
                                            // "最近两年同类排名",
                                            // "最近两年同类百分比排名",
                                            mrfFlag ? "最近两年同类百分比排名" : "最近两年同类排名",
                                            "最近三年年化回报率（%）",
                                            "最近三年总回报率（%）",
                                            // "最近三年同类排名",
                                            // "最近三年同类百分比排名",
                                            mrfFlag ? "最近三年同类百分比排名" : "最近三年同类排名",
                                            "最近五年年化回报率（%）",
                                            "最近五年总回报率（%）",
                                            // "最近五年同类排名",
                                            // "最近五年同类百分比排名",
                                            mrfFlag ? "最近五年同类百分比排名" : "最近五年同类排名",
                                            "最近七年年化回报率（%）",
                                            "最近七年总回报率（%）",
                                            // "最近七年同类排名",
                                            // "最近七年同类百分比排名",
                                            mrfFlag ? "最近七年同类百分比排名" : "最近七年同类排名",
                                            "最近十年年化回报率（%）",
                                            "最近十年总回报率（%）",
                                            // "最近十年同类排名",
                                            // "最近十年同类百分比排名", 
                                            mrfFlag ? "最近十年同类百分比排名" : "最近十年同类排名",
                                            "最近十五年年化回报率（%）",
                                            "最近十五年总回报率（%）",
                                            // "最近十五年同类排名",
                                            // "最近十五年同类百分比排名",
                                            mrfFlag ? "最近十五年同类百分比排名" : "最近十五年同类排名",
                                            "成立以来总回报率（%）",
                                            "晨星分类",
                                            "晨星分类组别",
                                            "晨星资产大类",
                                            "是否最早份额",
                                            "是否转型基金"
                                        ]
                                    ];
                                    for (let i = 0; i < fundList.length; i++) {
                                        if (fundList[i].defaultSymbol) {
                                            var row = [];
                                            row.push(fundList[i].defaultSymbol);
                                            row.push(fundList[i].legalName);
                                            row.push(fundList[i].categoryName);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].inceptionDate == null ? "":fundList[i].inceptionDate
                                                )
                                            );
                                            row.push(fundList[i].starRating3);
                                            row.push(fundList[i].starRating5);
                                            row.push(fundList[i].starRating10);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].priceDate == null ? "":fundList[i].priceDate
                                                )
                                            );
                                            row.push(fundList[i].nav);
                                            row.push(fundList[i].return1Day);
                                            row.push(fundList[i].returnYTD);

                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentileM0Rank
                                            );
                                            } else {
                                                row.push(fundList[i].returnYTDRank);
                                            }
                                                                                       
                                            row.push(fundList[i].return1Week);

                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile1WRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return1WeekRank
                                            );
                                            }                                        
                                            
                                            row.push(fundList[i].return1Month);
                                            
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile1MRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return1MonthRank
                                            );
                                            }
                                            
                                            row.push(fundList[i].return3Month);
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile3MRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return3MonthRank
                                            );
                                            }
                                                                           
                                            row.push(fundList[i].return6Month);
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile6MRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return6MonthRank
                                            );
                                            }
                                            
                                            row.push(fundList[i].return1Year);
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile1YRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return1YearRank
                                            );
                                            }
                                                                                  
                                            row.push(fundList[i].return2Year);
                                            row.push(
                                                fundList[i].accReturn2Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile2YRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return2YearRank
                                            );
                                            }
                                                                                      
                                            row.push(fundList[i].return3Year);
                                            row.push(
                                                fundList[i].accReturn3Year
                                            );
                                            if(mrfFlag) {
                                                row.push(
                                                fundList[i].percentile3YRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return3YearRank
                                            );
                                            }
                                                                                      
                                            row.push(fundList[i].return5Year);
                                            row.push(
                                                fundList[i].accReturn5Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile5YRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return5YearRank
                                            );
                                            }
                                                                                      
                                            row.push(fundList[i].return7Year);
                                            row.push(
                                                fundList[i].accReturn7Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile7YRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return7YearRank
                                            );
                                            }
                                                                                      
                                            row.push(fundList[i].return10Year);
                                            row.push(
                                                fundList[i].accReturn10Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile10YRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return10YearRank
                                            );
                                            }                                        
                                            
                                            row.push(fundList[i].return15Year);
                                            row.push(
                                                fundList[i].accReturn15Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile15YRank
                                            );
                                            } else {
                                                row.push(
                                                fundList[i].return15YearRank
                                            );
                                            }                                        
                                            
                                            row.push(
                                                fundList[i].returnInception
                                            );

                                            row.push(fundList[i].categoryNameLocal);
                                            row.push(fundList[i].categoryGroupName);
                                            row.push(fundList[i].broadCategoryName_CN);
                                            row.push(
                                                fundList[i].ifOldestShare === true || fundList[i].ifOldestShare === "true"
                                                    ? "是"
                                                    : fundList[i].ifOldestShare === false || fundList[i].ifOldestShare === "false"
                                                    ? "否"
                                                    : "--"
                                            );
                                            row.push(
                                                fundList[i].ifPeerGroupMembershipChange === true || fundList[i].ifPeerGroupMembershipChange === "true"
                                                    ? "是"
                                                    : fundList[i].ifPeerGroupMembershipChange === false || fundList[i].ifPeerGroupMembershipChange === "false"
                                                    ? "否"
                                                    : "--"
                                            );
                                            exportData.push(row);
                                        }
                                    }
                                } else {
                                    exportData = [
                                        [
                                            "基金代码",
                                            "基金名称",
                                            "基金类型",
                                            "成立日期",
                                            "晨星评级（三年）",
                                            "晨星评级（五年）",
                                            "晨星评级（十年）",
                                            "最新净值日期",
                                            "单位净值（元）",
                                            "今年以来总回报率（%）",
                                            "最近一周总回报率（%）",
                                            "最近一月总回报率（%）",
                                            "最近三月总回报率（%）",
                                            "最近六月总回报率（%）",
                                            "最近一年总回报率（%）",
                                            "最近一年同类排名",
                                            mrfFlag ? "最近一年同类百分比排名" : "",                                        
                                            "最近两年年化回报率（%）",
                                            "最近两年总回报率（%）",
                                            "最近两年同类排名",
                                            mrfFlag ? "最近两年同类百分比排名" : "",
                                            "最近三年年化回报率（%）",
                                            "最近三年总回报率（%）",
                                            "最近三年同类排名",
                                            mrfFlag ? "最近三年同类百分比排名" : "",
                                            "最近五年年化回报率（%）",
                                            "最近五年总回报率（%）",
                                            "最近五年同类排名",
                                            mrfFlag ? "最近五年同类百分比排名" : "",                                         
                                            "最近七年年化回报率（%）",
                                            "最近七年总回报率（%）",
                                            "最近七年同类排名",
                                            mrfFlag ? "最近七年同类百分比排名" : "",
                                            "最近十年年化回报率（%）",
                                            "最近十年总回报率（%）",
                                            "最近十年同类排名",
                                            mrfFlag ? "最近十年同类百分比排名" : "",
                                            "最近十五年年化回报率（%）",
                                            "最近十五年总回报率（%）",
                                            "最近十五年同类排名",
                                            mrfFlag ? "最近十五年同类百分比排名" : "",
                                            "成立以来总回报率（%）",
                                            "晨星分类",
                                            "晨星分类组别",
                                            "晨星资产大类",
                                            "是否最早份额",
                                            "是否转型基金"
                                        ].filter(item => item !== "")
                                    ];
                                    for (let i = 0; i < fundList.length; i++) {
                                        if (fundList[i].defaultSymbol) {
                                            var row = [];
                                            row.push(fundList[i].defaultSymbol);
                                            row.push(fundList[i].legalName);
                                            row.push(fundList[i].categoryName);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].inceptionDate == null ? "":fundList[i].inceptionDate
                                                )
                                            );
                                            row.push(fundList[i].starRating3);
                                            row.push(fundList[i].starRating5);
                                            row.push(fundList[i].starRating10);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].priceDate == null ? "":fundList[i].priceDate
                                                )
                                            );
                                            row.push(fundList[i].nav);
                                            row.push(fundList[i].returnYTD);
                                            row.push(fundList[i].return1Week);
                                            row.push(fundList[i].return1Month);
                                            row.push(fundList[i].return3Month);
                                            row.push(fundList[i].return6Month);
                                            row.push(fundList[i].return1Year);
                                            if(mrfFlag) {
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].absolute1YRank
                                                )
                                            );
                                            } else {
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].return1YearRank 
                                                )
                                            );
                                            }
                                            if(mrfFlag){
                                                row.push(
                                                fundList[i].percentile1YRank
                                            );
                                            }                                                                                 
                                            
                                            row.push(fundList[i].return2Year);
                                            row.push(
                                                fundList[i].accReturn2Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].absolute2YRank 
                                                )
                                            );
                                            } else {
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].return2YearRank 
                                                )
                                            );
                                            }
                                            
                                            if(mrfFlag){
                                                row.push(
                                                    fundList[i].percentile2YRank
                                                );
                                            }
                                                
                                            
                                            row.push(fundList[i].return3Year);
                                            row.push(
                                                fundList[i].accReturn3Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].absolute3YRank 
                                                )
                                            );
                                            }else{
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].return3YearRank 
                                                )
                                            );
                                            }   
                                            
                                            if(mrfFlag){
                                                row.push(
                                                    fundList[i].percentile3YRank
                                                );
                                            }
                                                                                           
                                            row.push(fundList[i].return5Year);
                                            row.push(
                                                fundList[i].accReturn5Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].absolute5YRank 
                                                )
                                            );
                                            } else {
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].return5YearRank 
                                                )
                                            );
                                            }
                                        
                                            if (mrfFlag){
                                                row.push(
                                                    fundList[i].percentile5YRank
                                                );
                                            }                                                                                          
                                            
                                            row.push(fundList[i].return7Year);
                                            row.push(
                                                fundList[i].accReturn7Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].absolute7YRank 
                                                )
                                            );
                                            } else {
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].return7YearRank 
                                                )
                                            );
                                            }
                                            if(mrfFlag) {
                                                row.push(
                                                    fundList[i].percentile7YRank
                                                );
                                            }
                                                                                                                         
                                            row.push(fundList[i].return10Year);
                                            row.push(
                                                fundList[i].accReturn10Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].absolute10YRank 
                                                )
                                            );
                                            } else{
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].return10YearRank 
                                                )
                                            );
                                            }
                                            if(mrfFlag){
                                                row.push(
                                                    fundList[i].percentile10YRank
                                                );
                                            }
                                                                                                                                   
                                            row.push(fundList[i].return15Year);
                                            row.push(
                                                fundList[i].accReturn15Year
                                            );
                                            if(mrfFlag){
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].absolute15YRank 
                                                )
                                            );
                                            } else {
                                                row.push(
                                                self.fillNull(
                                                    fundList[i].return15YearRank 
                                                )
                                            );
                                            }
                                            if(mrfFlag){
                                                row.push(
                                                    fundList[i].percentile15YRank
                                                );
                                            }

                                            row.push(
                                                fundList[i].returnInception
                                            );

                                            row.push(fundList[i].categoryNameLocal);
                                            row.push(fundList[i].categoryGroupName);
                                            row.push(fundList[i].broadCategoryName_CN);
                                            row.push(
                                                fundList[i].ifOldestShare === true || fundList[i].ifOldestShare === "true"
                                                    ? "是"
                                                    : fundList[i].ifOldestShare === false || fundList[i].ifOldestShare === "false"
                                                        ? "否"
                                                        : "--"
                                            );
                                            row.push(
                                                fundList[i].ifPeerGroupMembershipChange === true || fundList[i].ifPeerGroupMembershipChange === "true"
                                                    ? "是"
                                                    : fundList[i].ifPeerGroupMembershipChange === false || fundList[i].ifPeerGroupMembershipChange === "false"
                                                        ? "否"
                                                        : "--"
                                            );
                                            exportData.push(row);
                                        }
                                    }
                                }
                                } else {
                                //特殊逻辑，日榜月榜北上基金数据和其他类型的基金有差异用特殊模板                                                                                                                                                                             
                                //exportData是过滤掉北上基金的数据，导出全量基金，exportDataMRF是北上基金的数据
                                if (self.showDailylyRankingDate) {
                                    exportData = [
                                        [
                                            "基金代码",
                                            "基金名称",
                                            "基金类型",
                                            "成立日期",
                                            "晨星评级（三年）",
                                            "晨星评级（五年）",
                                            "晨星评级（十年）",
                                            "最新净值日期",
                                            "单位净值（元）",
                                            "日回报率（%）",
                                            "今年以来总回报率（%）",
                                            "今年以来同类排名",
                                            "最近一周总回报率（%）",
                                            "最近一周同类排名",
                                            "最近一月总回报率（%）",
                                            "最近一月同类排名",
                                            "最近三月总回报率（%）",
                                            "最近三月同类排名",
                                            "最近六月总回报率（%）",
                                            "最近六月同类排名",
                                            "最近一年总回报率（%）",
                                            "最近一年同类排名",
                                            "最近两年年化回报率（%）",
                                            "最近两年总回报率（%）",
                                            "最近两年同类排名",
                                            "最近三年年化回报率（%）",
                                            "最近三年总回报率（%）",
                                            "最近三年同类排名",
                                            "最近五年年化回报率（%）",
                                            "最近五年总回报率（%）",
                                            "最近五年同类排名",
                                            "最近七年年化回报率（%）",
                                            "最近七年总回报率（%）",
                                            "最近七年同类排名",
                                            "最近十年年化回报率（%）",
                                            "最近十年总回报率（%）",
                                            "最近十年同类排名",
                                            "最近十五年年化回报率（%）",
                                            "最近十五年总回报率（%）",
                                            "最近十五年同类排名",
                                            "成立以来总回报率（%）",
                                            "晨星分类",
                                            "晨星分类组别",
                                            "晨星资产大类",
                                            "是否最早份额",
                                            "是否转型基金"
                                        ]
                                    ];
                                    for (let i = 0; i < fundList.length; i++) {
                                        if (fundList[i].defaultSymbol) {
                                            var row = [];
                                            row.push(fundList[i].defaultSymbol);
                                            row.push(fundList[i].legalName);
                                            row.push(fundList[i].categoryName);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].inceptionDate == null ? "":fundList[i].inceptionDate
                                                )
                                            );
                                            row.push(fundList[i].starRating3);
                                            row.push(fundList[i].starRating5);
                                            row.push(fundList[i].starRating10);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].priceDate == null ? "":fundList[i].priceDate
                                                )
                                            );
                                            row.push(fundList[i].nav);
                                            row.push(fundList[i].return1Day);
                                            row.push(fundList[i].returnYTD);
                                            row.push(fundList[i].returnYTDRank);                                                                                                                                
                                            row.push(fundList[i].return1Week);
                                            row.push(
                                                fundList[i].return1WeekRank
                                            );                                                                              
                                            row.push(fundList[i].return1Month);                                                                                     
                                            row.push(
                                                fundList[i].return1MonthRank
                                            );                                           
                                            row.push(fundList[i].return3Month);
                                            row.push(
                                                fundList[i].return3MonthRank
                                            );                                                                                                                   
                                            row.push(fundList[i].return6Month);
                                            row.push(
                                                fundList[i].return6MonthRank
                                            );                                          
                                            row.push(fundList[i].return1Year);
                                            row.push(
                                                fundList[i].return1YearRank
                                            );                                                                               
                                            row.push(fundList[i].return2Year);
                                            row.push(
                                                fundList[i].accReturn2Year
                                            );
                                            row.push(
                                                fundList[i].return2YearRank
                                            );                                                                                    
                                            row.push(fundList[i].return3Year);
                                            row.push(
                                                fundList[i].accReturn3Year
                                            );
                                            row.push(
                                                fundList[i].return3YearRank
                                            );                                                                                   
                                            row.push(fundList[i].return5Year);
                                            row.push(
                                                fundList[i].accReturn5Year
                                            );
                                            row.push(
                                                fundList[i].return5YearRank
                                            );                                                                                  
                                            row.push(fundList[i].return7Year);
                                            row.push(
                                                fundList[i].accReturn7Year
                                            );
                                            row.push(
                                                fundList[i].return7YearRank
                                            );                                                                                    
                                            row.push(fundList[i].return10Year);
                                            row.push(
                                                fundList[i].accReturn10Year
                                            );
                                            row.push(
                                                fundList[i].return10YearRank
                                            );
                                            row.push(fundList[i].return15Year);
                                            row.push(
                                                fundList[i].accReturn15Year
                                            );
                                            row.push(
                                                fundList[i].return15YearRank
                                            );
                                            row.push(
                                                fundList[i].returnInception
                                            );

                                            row.push(fundList[i].categoryNameLocal);
                                            row.push(fundList[i].categoryGroupName);
                                            row.push(fundList[i].broadCategoryName_CN);
                                            row.push(
                                                fundList[i].ifOldestShare === true || fundList[i].ifOldestShare === "true"
                                                    ? "是"
                                                    : fundList[i].ifOldestShare === false || fundList[i].ifOldestShare === "false"
                                                        ? "否"
                                                        : "--"
                                            );
                                            row.push(
                                                fundList[i].ifPeerGroupMembershipChange === true || fundList[i].ifPeerGroupMembershipChange === "true"
                                                    ? "是"
                                                    : fundList[i].ifPeerGroupMembershipChange === false || fundList[i].ifPeerGroupMembershipChange === "false"
                                                        ? "否"
                                                        : "--"
                                            );
                                            exportData.push(row);
                                        }
                                    }
                                } else {
                                    exportData = [
                                        [
                                            "基金代码",
                                            "基金名称",
                                            "基金类型",
                                            "成立日期",
                                            "晨星评级（三年）",
                                            "晨星评级（五年）",
                                            "晨星评级（十年）",
                                            "最新净值日期",
                                            "单位净值（元）",
                                            "今年以来总回报率（%）",
                                            "最近一周总回报率（%）",
                                            "最近一月总回报率（%）",
                                            "最近三月总回报率（%）",
                                            "最近六月总回报率（%）",
                                            "最近一年总回报率（%）",
                                            "最近一年同类排名",                                                                           
                                            "最近两年年化回报率（%）",
                                            "最近两年总回报率（%）",
                                            "最近两年同类排名",
                                            "最近三年年化回报率（%）",
                                            "最近三年总回报率（%）",
                                            "最近三年同类排名",
                                            "最近五年年化回报率（%）",
                                            "最近五年总回报率（%）",
                                            "最近五年同类排名",                                      
                                            "最近七年年化回报率（%）",
                                            "最近七年总回报率（%）",
                                            "最近七年同类排名",
                                            "最近十年年化回报率（%）",
                                            "最近十年总回报率（%）",
                                            "最近十年同类排名",
                                            "最近十五年年化回报率（%）",
                                            "最近十五年总回报率（%）",
                                            "最近十五年同类排名",
                                            "成立以来总回报率（%）",
                                            "晨星分类",
                                            "晨星分类组别",
                                            "晨星资产大类",
                                            "是否最早份额",
                                            "是否转型基金"
                                        ].filter(item => item !== "")
                                    ];
                                    for (let i = 0; i < fundList.length; i++) {
                                        if (fundList[i].defaultSymbol) {
                                            var row = [];
                                            row.push(fundList[i].defaultSymbol);
                                            row.push(fundList[i].legalName);
                                            row.push(fundList[i].categoryName);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].inceptionDate == null ? "":fundList[i].inceptionDate
                                                )
                                            );
                                            row.push(fundList[i].starRating3);
                                            row.push(fundList[i].starRating5);
                                            row.push(fundList[i].starRating10);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].priceDate == null ? "":fundList[i].priceDate
                                                )
                                            );
                                            row.push(fundList[i].nav);
                                            row.push(fundList[i].returnYTD);
                                            row.push(fundList[i].return1Week);
                                            row.push(fundList[i].return1Month);
                                            row.push(fundList[i].return3Month);
                                            row.push(fundList[i].return6Month);
                                            row.push(fundList[i].return1Year);
                                            row.push(
                                                self.fillNull(
                                                    fundList[i].return1YearRank 
                                                )
                                            );                                                                                                                          
                                            row.push(fundList[i].return2Year);
                                            row.push(
                                                fundList[i].accReturn2Year
                                            );
                                            row.push(
                                                self.fillNull(
                                                    fundList[i].return2YearRank 
                                                )
                                            );                                                                                                                                                                         
                                            row.push(fundList[i].return3Year);
                                            row.push(
                                                fundList[i].accReturn3Year
                                            );
                                            row.push(
                                                self.fillNull(
                                                    fundList[i].return3YearRank 
                                                )
                                            );                                                                                                                                                                             
                                            row.push(fundList[i].return5Year);
                                            row.push(
                                                fundList[i].accReturn5Year
                                            );
                                            row.push(
                                                self.fillNull(
                                                    fundList[i].return5YearRank 
                                                )
                                            );                                 
                                            row.push(fundList[i].return7Year);
                                            row.push(
                                                fundList[i].accReturn7Year
                                            );
                                            row.push(
                                                self.fillNull(
                                                    fundList[i].return7YearRank 
                                                )
                                            );                                                                                                                     
                                            row.push(fundList[i].return10Year);
                                            row.push(
                                                fundList[i].accReturn10Year
                                            );
                                            row.push(
                                                self.fillNull(
                                                    fundList[i].return10YearRank 
                                                )
                                            );                                                                                     
                                            row.push(fundList[i].return15Year);
                                            row.push(
                                                fundList[i].accReturn15Year
                                            );
                                            row.push(
                                                self.fillNull(
                                                    fundList[i].return15YearRank 
                                                )
                                            );
                                            row.push(
                                                fundList[i].returnInception
                                            );

                                            row.push(fundList[i].categoryNameLocal);
                                            row.push(fundList[i].categoryGroupName);
                                            row.push(fundList[i].broadCategoryName_CN);
                                            row.push(
                                                fundList[i].ifOldestShare === true || fundList[i].ifOldestShare === "true"
                                                    ? "是"
                                                    : fundList[i].ifOldestShare === false || fundList[i].ifOldestShare === "false"
                                                        ? "否"
                                                        : "--"
                                            );
                                            row.push(
                                                fundList[i].ifPeerGroupMembershipChange === true || fundList[i].ifPeerGroupMembershipChange === "true"
                                                    ? "是"
                                                    : fundList[i].ifPeerGroupMembershipChange === false || fundList[i].ifPeerGroupMembershipChange === "false"
                                                        ? "否"
                                                        : "--"
                                            );
                                            exportData.push(row);
                                        }
                                    }
                                }
                                }
                                if(self.exportOption == "fullList"){

                                if (self.showDailylyRankingDate) {
                                    exportDataMRF   = [
                                        [
                                            "基金代码",
                                            "基金名称",
                                            "基金类型",
                                            "成立日期",
                                            "晨星评级（三年）",
                                            "晨星评级（五年）",
                                            "晨星评级（十年）",
                                            "最新净值日期",
                                            "单位净值（元）",
                                            "日回报率（%）",
                                            "今年以来总回报率（%）",
                                            // "今年以来同类排名",
                                            "今年以来同类百分比排名",
                                            "最近一周总回报率（%）",
                                            // "最近一周同类排名",
                                            "最近一周同类百分比排名",
                                            "最近一月总回报率（%）",
                                            // "最近一月同类排名",
                                            "最近一月同类百分比排名" ,
                                            "最近三月总回报率（%）",
                                            // "最近三月同类排名",
                                            "最近三月同类百分比排名",
                                            "最近六月总回报率（%）",
                                            // "最近六月同类排名",
                                            "最近六月同类百分比排名",
                                            "最近一年总回报率（%）",
                                            // "最近一年同类排名",
                                            "最近一年同类百分比排名",
                                            "最近两年年化回报率（%）",
                                            "最近两年总回报率（%）",
                                            // "最近两年同类排名",
                                            "最近两年同类百分比排名",
                                            "最近三年年化回报率（%）",
                                            "最近三年总回报率（%）",
                                            // "最近三年同类排名",
                                            "最近三年同类百分比排名",
                                            "最近五年年化回报率（%）",
                                            "最近五年总回报率（%）",
                                            // "最近五年同类排名",
                                            "最近五年同类百分比排名",
                                            "最近七年年化回报率（%）",
                                            "最近七年总回报率（%）",
                                            // "最近七年同类排名",
                                            "最近七年同类百分比排名",
                                            "最近十年年化回报率（%）",
                                            "最近十年总回报率（%）",
                                            // "最近十年同类排名",
                                            "最近十年同类百分比排名", 
                                            "最近十五年年化回报率（%）",
                                            "最近十五年总回报率（%）",
                                            // "最近十五年同类排名",
                                            "最近十五年同类百分比排名",
                                            // mrfFlag ? "最近十五年同类百分比排名" : "最近十五年同类排名",
                                            "成立以来总回报率（%）",
                                            "晨星分类",
                                            "晨星分类组别",
                                            "晨星资产大类",
                                            "是否最早份额",
                                            "是否转型基金"
                                        ]
                                    ];
                                    for (let i = 0; i < fundListMRF.length; i++) {                                       
                                        if (fundListMRF[i].defaultSymbol) {
                                            var row = [];
                                            row.push(fundListMRF[i].defaultSymbol);
                                            row.push(fundListMRF[i].legalName);
                                            row.push(fundListMRF[i].categoryName);
                                            row.push(
                                                self.formatDate(
                                                    fundListMRF[i].inceptionDate == null ? "":fundListMRF[i].inceptionDate
                                                )
                                            );
                                            row.push(fundListMRF[i].starRating3);
                                            row.push(fundListMRF[i].starRating5);
                                            row.push(fundListMRF[i].starRating10);
                                            row.push(
                                                self.formatDate(
                                                    fundListMRF[i].priceDate == null ? "":fundListMRF[i].priceDate
                                                )
                                            );
                                            row.push(fundListMRF[i].nav);
                                            row.push(fundListMRF[i].return1Day);
                                            row.push(fundListMRF[i].returnYTD);
                                            row.push(
                                                fundListMRF[i].percentileM0Rank
                                            );
                                            row.push(fundListMRF[i].return1Week);
                                            row.push(
                                                fundListMRF[i].percentile1WRank
                                            );
                                            row.push(fundListMRF[i].return1Month);
                                            row.push(
                                                fundListMRF[i].percentile1MRank
                                            );
                                            row.push(fundListMRF[i].return3Month);
                                            row.push(
                                                fundListMRF[i].percentile3MRank
                                            );
                                            row.push(fundListMRF[i].return6Month);
                                            row.push(
                                                fundListMRF[i].percentile6MRank
                                            );
                                            row.push(fundListMRF[i].return1Year);
                                            row.push(
                                                fundListMRF[i].percentile1YRank
                                            );
                                            row.push(fundListMRF[i].return2Year);
                                            row.push(
                                                fundListMRF[i].accReturn2Year
                                            );
                                            row.push(
                                                fundListMRF[i].percentile2YRank
                                            );
                                            row.push(fundListMRF[i].return3Year);
                                            row.push(
                                                fundListMRF[i].accReturn3Year
                                            );
                                            row.push(
                                                fundListMRF[i].percentile3YRank
                                            );
                                            row.push(fundListMRF[i].return5Year);
                                            row.push(
                                                fundListMRF[i].accReturn5Year
                                            );
                                            row.push(
                                                fundListMRF[i].percentile5YRank
                                            );
                                            row.push(fundListMRF[i].return7Year);
                                            row.push(
                                                fundListMRF[i].accReturn7Year
                                            );
                                            row.push(
                                                fundListMRF[i].percentile7YRank
                                            );
                                            row.push(fundListMRF[i].return10Year);
                                            row.push(
                                                fundListMRF[i].accReturn10Year
                                            );
                                            row.push(
                                                fundListMRF[i].percentile10YRank
                                            );
                                            row.push(fundListMRF[i].return15Year);
                                            row.push(
                                                fundListMRF[i].accReturn15Year
                                            );
                                            row.push(
                                                fundListMRF[i].percentile15YRank
                                            );
                                            row.push(
                                                fundListMRF[i].returnInception
                                            );
                                            exportDataMRF.push(row);
                                        }
                                    }
                                } else {
                                    exportDataMRF = [
                                        [
                                            "基金代码",
                                            "基金名称",
                                            "基金类型",
                                            "成立日期",
                                            "晨星评级（三年）",
                                            "晨星评级（五年）",
                                            "晨星评级（十年）",
                                            "最新净值日期",
                                            "单位净值（元）",
                                            "今年以来总回报率（%）",
                                            "最近一周总回报率（%）",
                                            "最近一月总回报率（%）",
                                            "最近三月总回报率（%）",
                                            "最近六月总回报率（%）",
                                            "最近一年总回报率（%）",
                                            "最近一年同类排名",
                                            "最近一年同类百分比排名",
                                            "最近两年年化回报率（%）",
                                            "最近两年总回报率（%）",
                                            "最近两年同类排名",
                                            "最近两年同类百分比排名",
                                            "最近三年年化回报率（%）",
                                            "最近三年总回报率（%）",
                                            "最近三年同类排名",
                                            "最近三年同类百分比排名",
                                            "最近五年年化回报率（%）",
                                            "最近五年总回报率（%）",
                                            "最近五年同类排名",
                                            "最近五年同类百分比排名",
                                            "最近七年年化回报率（%）",
                                            "最近七年总回报率（%）",
                                            "最近七年同类排名",
                                            "最近七年同类百分比排名" ,
                                            "最近十年年化回报率（%）",
                                            "最近十年总回报率（%）",
                                            "最近十年同类排名",
                                            "最近十年同类百分比排名",
                                            "最近十五年年化回报率（%）",
                                            "最近十五年总回报率（%）",
                                            "最近十五年同类排名",
                                            "最近十五年同类百分比排名",
                                            "成立以来总回报率（%）",
                                            "晨星分类",
                                            "晨星分类组别",
                                            "晨星资产大类",
                                            "是否最早份额",
                                            "是否转型基金"
                                        ]
                                    ];
                                  
                                    for (let i = 0; i < fundListMRF.length; i++) {
                                        if (fundListMRF[i].defaultSymbol) {
                                            var row = [];
                                            row.push(fundListMRF[i].defaultSymbol);
                                            row.push(fundListMRF[i].legalName);
                                            row.push(fundListMRF[i].categoryName);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].inceptionDate == null ? "":fundList[i].inceptionDate
                                                )
                                            );
                                            row.push(fundListMRF[i].starRating3);
                                            row.push(fundListMRF[i].starRating5);
                                            row.push(fundListMRF[i].starRating10);
                                            row.push(
                                                self.formatDate(
                                                    fundList[i].priceDate == null ? "":fundList[i].priceDate
                                                )
                                            );
                                            row.push(fundListMRF[i].nav);
                                            row.push(fundListMRF[i].returnYTD);
                                            row.push(fundListMRF[i].return1Week);
                                            row.push(fundListMRF[i].return1Month);
                                            row.push(fundListMRF[i].return3Month);
                                            row.push(fundListMRF[i].return6Month);
                                            row.push(fundListMRF[i].return1Year);

                                                row.push(
                                                self.fillNull(
                                                    fundListMRF[i].absolute1YRank
                                                )
                                                );
                                            
                                            
                                            row.push(
                                                fundListMRF[i].percentile1YRank
                                            );
                                            
                                            row.push(fundList[i].return2Year);
                                            row.push(
                                                fundListMRF[i].accReturn2Year
                                            );

                                                row.push(
                                                self.fillNull(
                                                    fundListMRF[i].absolute2YRank 
                                                )
                                                );

                                            
                                                row.push(
                                                    fundListMRF[i].percentile2YRank
                                                );
                                            
                                            row.push(fundListMRF[i].return3Year);
                                            row.push(
                                                fundListMRF[i].accReturn3Year
                                            );

                                                row.push(
                                                self.fillNull(
                                                    fundListMRF[i].absolute3YRank 
                                                )
                                                );
                                                                                      
                                                 row.push(
                                                    fundListMRF[i].percentile3YRank
                                                );
                                            
                                            row.push(fundListMRF[i].return5Year);
                                            row.push(
                                                fundListMRF[i].accReturn5Year
                                            );
                                                
                                                row.push(
                                                self.fillNull(
                                                    fundListMRF[i].absolute5YRank 
                                                )
                                                );
                                            
                                            
                                                row.push(
                                                    fundListMRF[i].percentile5YRank
                                                );
                                            
                                            row.push(fundListMRF[i].return7Year);
                                            row.push(
                                                fundListMRF[i].accReturn7Year
                                            );
                                                
                                                row.push(
                                                self.fillNull(
                                                    fundListMRF[i].absolute7YRank 
                                                )
                                                );
                                           
                                                row.push(
                                                    fundListMRF[i].percentile7YRank
                                                );
                                            
                                            row.push(fundListMRF[i].return10Year);
                                            row.push(
                                                fundListMRF[i].accReturn10Year
                                            );
                                            
                                                row.push(
                                                self.fillNull(
                                                    fundListMRF[i].absolute10YRank 
                                                )
                                                );
                                            
                                            
                                                row.push(
                                                    fundListMRF[i].percentile10YRank
                                                );
                                            
                                            row.push(fundListMRF[i].return15Year);
                                            row.push(
                                                fundListMRF[i].accReturn15Year
                                            );
                                            
                                                row.push(
                                                self.fillNull(
                                                    fundListMRF[i].absolute15YRank 
                                                )
                                                );
                                            
                                            
                                                row.push(
                                                    fundListMRF[i].percentile15YRank
                                                );
                                            
                                            row.push(
                                                fundListMRF[i].returnInception
                                            );

                                            row.push(fundList[i].categoryNameLocal);
                                            row.push(fundList[i].categoryGroupName);
                                            row.push(fundList[i].broadCategoryName_CN);
                                            row.push(
                                                fundList[i].ifOldestShare === true || fundList[i].ifOldestShare === "true"
                                                    ? "是"
                                                    : fundList[i].ifOldestShare === false || fundList[i].ifOldestShare === "false"
                                                        ? "否"
                                                        : "--"
                                            );
                                            row.push(
                                                fundList[i].ifPeerGroupMembershipChange === true || fundList[i].ifPeerGroupMembershipChange === "true"
                                                    ? "是"
                                                    : fundList[i].ifPeerGroupMembershipChange === false || fundList[i].ifPeerGroupMembershipChange === "false"
                                                        ? "否"
                                                        : "--"
                                            );
                                            exportDataMRF.push(row);
                                        }
                                    }
                                }

                                }
                                */
                                let dataSheet;
                                let dataMRFSheet;
                                if(self.exportOption == "currentList") {     

                                    dataSheet = XLSX.utils.aoa_to_sheet(
                                        exportData
                                    );
                                } else {
                                    dataSheet = XLSX.utils.aoa_to_sheet(
                                        exportData
                                    );
                                    dataMRFSheet  = XLSX.utils.aoa_to_sheet(
                                        exportDataMRF
                                    );
                                }                               
                                var note1 = "备注：";
                                var note2 =
                                    "注1：数据来源于Morningstar 晨星，本报告生成时间为" +
                                    new Date().format("yyyy/MM/dd HH:mm");
                                var note3 =
                                    "注2：最新的晨星评级数据截至" +
                                    self.getRatingDate(
                                        fundList[0].ratingYear,
                                        fundList[0].ratingMonth
                                    ) +
                                    "。";
                                var note4 =
                                    "注3：部分晨星分类不提供排名或评级，关于详细的晨星分类和评级方法请查阅http://www.morningstar.cn";
                                var note5 =
                                    "注4：月榜数据截止日为当月度最后一个自然日，如该月末日未公布净值，则向前取最新一个交易日净值；各回报期间的起始日仍然为月末日对应的起始日期，同样地，如对应起始日期无净值，则向前取最新一个交易日净值。";
                                var note6 =
                                    "免责声明：本公司不保证信息的准确性、完整性和及时性，同时也不保证本公司做出的任何建议或评论不会发生任何变更。过往业绩不代表将来业绩。基金评价结果并不是对未来表现的预测，也不应视作投资基金的建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯（深圳）有限公司所有。";
                                var note7 =
                                    "特别提醒：部分特殊类型基金业绩更新延迟，最终排名或有微调，如需即时引用请注明引用时间。";
                                var noteSheet = XLSX.utils.aoa_to_sheet([
                                    [note1],
                                    [note2],
                                    [note3],
                                    [note4],
                                    [note5],
                                    [],
                                    [note6]
                                ]);
                                if (!self.monthlyRankSignOff()) {
                                    XLSX.utils.sheet_add_aoa(
                                        noteSheet,
                                        [[note7]],
                                        { origin: "A9" }
                                    );
                                }
                                noteSheet["A1"].s = {
                                    font: {
                                        sz: 10
                                    }
                                };
                                if(self.exportOption == "currentList") {                                  
                                    openDownloadDialog(
                                    sheet2blob4Rank(
                                        XLSX,
                                        dataSheet,
                                        "数据",
                                        noteSheet,
                                        "备注"
                                    ),
                                    fileName + ".xlsx"
                                );
                                } else {
                                    openDownloadDialog(
                                    sheet2blob4RankMRF(
                                        XLSX,
                                        dataSheet,
                                        "数据",
                                        dataMRFSheet,
                                        "北上基金数据",
                                        noteSheet,
                                        "备注"
                                    ),
                                    fileName + ".xlsx"
                                );
                                }                          
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        getMonthlySignOffInfo(params) {
            const self = this;
            getMonthlyReportFixed(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                let data = result.data;
                                self.monthlySignOff =
                                    data.ifFixed == 1 ? true : false;
                                self.monthlyLastUpdate = data.lastUpdate;
                                if (!self.monthlySignOff) {
                                    self.openAlert();
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        getRatingDate(ratingYear, ratingMonth) {
            let strDate = ratingYear + "-" + ratingMonth;
            let date = new Date(strDate);
            let nDate = new Date(date.setMonth(date.getMonth() + 1));
            return new Date(
                nDate.setDate(nDate.getDate() - 1)
            ).toLocaleDateString();
        },
        getWorkDateFun(param) {
            const self = this;
            getWorkDate(param)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                let data = response.data.data;
                                if (
                                    response.data &&
                                    response.data.data &&
                                    response.data.data.length > 0
                                ) {
                                    self.dateValue = response.data.data[0];
                                    window.latestWorkDate =
                                        response.data.data[0];
                                    window.availableWorkDate =
                                        response.data.data;
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        setDateValueMonthlyToLastMonthendDateWhenItIsNull() {
            if (
                this.dateValueMonthly == null ||
                this.dateValueMonthly == "" ||
                this.dateValueMonthly == undefined
            ) {
                let newDate = new Date();
                let lastMonthEndDate = new Date(
                    newDate.getFullYear(),
                    newDate.getMonth(),
                    0
                );
                //this.dateValueMonthly = lastMonthEndDate.getFullYear() +"-"+(lastMonthEndDate.getMonth() + 1).toString().padStart(2,'0')+"-"+lastMonthEndDate.getDate();
                this.dateValueMonthly =
                    lastMonthEndDate.getFullYear() +
                    "-" +
                    (lastMonthEndDate.getMonth() + 1)
                        .toString()
                        .padStart(2, "0");
            }
        },
        openAlert() {
            this.$alert(
                "部分特殊类型基金业绩更新延迟，最终排名或有微调，如需即时引用请注明引用时间。",
                "提醒",
                {
                    confirmButtonText: "确定"
                }
            );
        },
        formatDate(date) {
            if (date.indexOf("00:00:00.0") > -1) {
                date = date.replace(" 00:00:00.0", "");
            } else {
                date = new Date(date).format("yyyy/MM/dd");
            }
            return date;
        },
        fillNull(value) {
            if (value != undefined && value != null && value != "" && value != "null/null") {
                return value;              
            } else {
                return "";
            }
        },
        monthlyRankSignOff() {
            const self = this;
            if (self.showMonthlyRankingDate && !self.monthlySignOff) {
                return false;
            }
            return true;
        },
        fillConfigData() {
            const self = this;
            self.configSendDialogVisible = true;
            var params = {};
            if (self.rankingType == "dailyRanking") {
                params = { type: 1 };
            } else {
                params = { type: 2 };
            }
            getSubscription(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            self.emailsParagraph = result.data.subscription;
                            if (self.showDailylyRankingDate) {
                                self.selectFrequencyDaily =
                                    result.data.frequency;
                            } else {
                                self.selectFrequencyMonthly =
                                    result.data.frequency;
                            }
                            self.configResendNeeded = false;
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.dialogLoading = false;
                });
        },
        fillConfigDataMonthly() {
            const self = this;
            self.configSendDialogVisibleMonthly = true;
            var params = {};
            // if (self.rankingType == "dailyRanking") {
            //     params = { type: 1 };
            // } else {
            //     params = { type: 2 };
            // }
            getSubscriptionMonthly(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            self.emailsParagraphMonthly = result.data.subscription;
                            self.myListCompanyMonthly = result.data.myListCompany;
                            self.configResendNeededMonthly = false;
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.dialogLoading = false;
                });
        },
        savaSubscritionInfo() {
            const self = this;
            self.configSendDialogVisible = false;
            self.dialogLoading = true;
            let params = {
                subscription: self.emailsParagraph
            };
            if (self.showDailylyRankingDate) {
                params.type = 1;
                params.frequency = self.selectFrequencyDaily;
            } else {
                params.type = 2;
                params.frequency = self.selectFrequencyMonthly;
            }
            self.editConfig(params);
        },
        editConfig(params) {
            const self = this;
            editSubscription(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            Message({
                                message: "设置成功",
                                type: "success",
                                duration: 2 * 1000
                            });
                            Message.close = function() {
                                // self.loadingData();
                            };
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.configResendNeeded = true;
                    self.dialogLoading = false;
                });
        },
        sendRankReport() {
            const self = this;
            self.dialogLoading = true;
            self.savaSubscritionInfo();
            let params = {};
            if (self.showDailylyRankingDate) {
                params = { type: 1 };
            } else {
                params = { type: 2 };
            }
            sendRankReportByEmail(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                    } else {
                        if (checkResponseStatus(result, self)) {
                            Message({
                                message: "定时任务已启动，请半小时后查看邮箱",
                                type: "success",
                                duration: 5 * 1000
                            });
                            Message.close = function() {
                                //self.loadInfoData();
                            };
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.configResendNeeded = true;
                    self.dialogLoading = false;
                });
        },
        sendRankReportMonthly() {
            const self = this;
            self.dialogLoading = true;
            self.savaSubscritionInfoMonthly();
            let params = { reportDate: self.dateValueMonthly};

            sendRankReportByEmailMonthly(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                    } else {
                        if (checkResponseStatus(result, self)) {
                            Message({
                                message: "定时任务已启动，请半小时后查看邮箱",
                                type: "success",
                                duration: 5 * 1000
                            });
                            Message.close = function() {
                                //self.loadInfoData();
                            };
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.configResendNeeded = true;
                    self.dialogLoading = false;
                });
        },
        savaSubscritionInfoMonthly() {
            const self = this;
            self.configSendDialogVisibleMonthly = false;
            self.dialogLoading = true;
            let params = {
                myListCompany: self.myListCompanyMonthly,
                subscription: self.emailsParagraphMonthly
            };
            // if (self.showDailylyRankingDate) {
            //     params.type = 1;
            //     params.frequency = self.selectFrequencyDaily;
            // } else {
            //     params.type = 2;
            //     params.frequency = self.selectFrequencyMonthly;
            // }

            console.log("myListCompanyMonthly",self.myListCompanyMonthly);
            console.log("emailsParagraphMonthly",self.emailsParagraphMonthly);
            self.editConfigMonthly(params);
        },
        editConfigMonthly(params) {
            const self = this;
            editSubscriptionMonthly(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            Message({
                                message: "设置成功",
                                type: "success",
                                duration: 2 * 1000
                            });
                            Message.close = function() {
                                // self.loadingData();
                            };
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.configResendNeededMonthly = true;
                    self.dialogLoading = false;
                });
        },
       
    }
};

Date.prototype.format = function(fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
    return fmt;
};
</script>
<style lang="scss">
@import "../../public/sass/components/ranking";

.red span {
    border: 1px solid red;
    border-radius: 50%;
}

#elselectFundOrCompany.el-input__inner {
    width: 100px !important;
    margin-right: -10px !important;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}

#elselectCompany.el-input__inner,
#elselectFund.el-input__inner {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

.imgs_logo {
    height: 25px;
    width: 100px;
    margin-top: -3%;
    margin-left: 69%;
    background: url("../../public/images/logo_image.png") no-repeat;
}
</style>